<template>
    <div>
      <div>
        <div
          class="dashboard-content-inner my_custom_dash employer_manage_job employer_manage_job_admin_nw mobile_min_width_1000 desktop_padding_top_zero"
        >
          <!-- Dashboard Headline -->
          <div class="dashboard-headline heading_with_btn manage_jobs_new_layout_btn">
            <h1>Manage Jobs</h1>  
          </div>
          <!-- Row -->
          <!-- <div class="row emplpyees_manage_job_emp_row" > -->
          <div class="row">
            <!-- Dashboard Box -->
            <!-- <div class="col-xl-12 mobile_left_right_zero_pdng"> -->
            <div class="col-xl-12">
              <div class="dashboard-box11 desktop_margin_top_zero">
                <!-- </div> -->
                <div class="tab-section  manage_job_new_tabs_layout manage_job_new_tabs_layout_admin_nw manage_multiple_top_div">
                  <b-tabs class="my_tab_job remove_bx new_remove_bx_manage_multiple common_tab_scroll">
                    <b-tab
                      :title="'Edit Multiple Jobs'"
                      class="common_pading_for_check_box"
                      @click="clear"
                    >
                    <!-- <div class="row"> -->
                      <div class="dashboard-box mt-0 center_radio_btn_with_text common_padding_20">
                        <b-form method="post" id="add-applicants-form" class="nw_frm ">
                            <div class="row">
                                <div class="col-xl-12">
                                <!-- <div class="dashboard-box desktop_margin_top_zero"> -->
                                    <!-- <div class="col-xl-12 cat_inner_divs w-100"> -->
                                        <div class="submit-field error_submit_field ">
                                        <h5>Company Name<span class="required_star">*</span></h5>
                                        <multiselect
                                            v-model="companyName"
                                            id="ajax"
                                            label="name"
                                            track-by="id"
                                            placeholder="Search by keyword"
                                            open-direction="bottom"
                                            :options="selectedCompany"
                                            :searchable="true"
                                            :clear-on-select="true"
                                            :close-on-select="true"
                                            :allow-empty="true"
                                            @input="onCompanyChange(companyName,0)"
                                            class="common_multiselect_placeholder new_multi_slec_list job_list_multi_select multiselect_border job_id_noti job_id_noti_multiple"
                                        >
                                            <span slot="noResult">No Company Found.</span>
                                        </multiselect>
                                        </div>
                                    <!-- </div> -->
                                <!-- </div>   -->
                            </div>
                            <div class="col-xl-12">
                              <div class="">
                              <div class="single_accordian broadcast_faq_new mb-3 mt-1">
                              <!-- <br> -->
                              <!-- <div> -->
                                <div class="faq-content-box clearfix">
                                  <div>
                                    <div class="accordion-listing-box ">
                                      <b-card no-body>
                                        <b-card-header header-tag="header" role="tab">
                                          <b-button
                                            v-b-toggle="
                                              'accordion_edit_multiple_job'
                                            "
                                            class="m-1"
                                            variant="info"
                                          >
                                            <div class="dashboard-box">
                                              <div class="headline">
                                                <h3 class="red_option">Optional Filters</h3>
                                              </div>
                                            </div>
                                          </b-button>
                                        </b-card-header>
                                        <b-collapse
                                          :id="'accordion_edit_multiple_job'"
                                          role="tabpanel"
                                        >
                                          <b-card-body>
                                            <div class="">
                                              <div class="row">
                                                <div class="col-xl-12">
                                                  <b-row>
                                                      <b-col xl="4"  class="search_by_keyword_manage_multple submit-field admin_listing_search new_search_div_daily_job">
                                                        <!-- <h5>Search by keyword</h5> -->
                                                        <!-- <b-form-group label="" class="mb-0"> -->
                                                          <!-- <b-input-group> -->
                                                          <div class="search-box custom_search_admin desktop_margin_top_zero">
                                                            <b-input-group-prepend>
                                                              <b-form-input
                                                                id="searchBtn"
                                                                v-model="searchKeyword"
                                                                placeholder="Search by keyword"
                                                                v-on:keyup.enter="dateFilter(0)"
                                                                class="with-border"
                                                              ></b-form-input>
                                                              <!-- <b-input-group-append> -->
                                                                <b-button class="btn points_events" @click="dateFilter(0)">
                                                                  <i class="fa fa-search"></i>
                                                                </b-button>
                                                              <!-- </b-input-group-append> -->
                                                            </b-input-group-prepend>
                                                          </div>
                                                          <!-- </b-input-group> -->
                                                        <!-- </b-form-group> -->
                                                      </b-col>

                                                        <b-col xl="8"  class="submit-field">
                                                          <!-- <h5>Address</h5> -->
                                                            <b-form-group id="input-group-8" label="" class="mb-0">
                                                                <multiselect v-model="address" id="ajax" label="address" track-by="id"  placeholder="Type to search address" open-direction="bottom" :multiple="isMultiple" :options="selectedAddress"  :searchable="true" :clear-on-select="false" :close-on-select="false" 
                                                                :allow-empty="true" @close="dateFilter(0)" class="common_multiselect_placeholder new_multi_slec_list job_list_multi_select multiselect_border">
                                                                    <span slot="noResult">No Address Found.</span>
                                                                </multiselect>
                                                            </b-form-group>
                                                        </b-col>
                                                        <b-col xl="4"  class="submit_field_big_screen_and_mobile">
                                                        <!-- <h5>Start Time</h5> -->
                                                          <b-form-group label="" class="mb-0">
                                                            <multiselect v-model="time" id="ajax" label="start_time" track-by="id" placeholder="Select start time" open-direction="bottom" :multiple="isMultiple" :options="selectedTime" :searchable="true" :clear-on-select="false" :close-on-select="false" :allow-empty="true" @close="dateFilter(1)" class="common_multiselect_placeholder new_multi_slec_list job_list_multi_select multiselect_border">
                                                              <span slot="noResult">No Start Time Found.</span>
                                                            </multiselect>
                                                          </b-form-group>
                                                        </b-col>

                                                        <b-col xl="4"  class="submit_field_big_screen_and_mobile">
                                                          <!-- <h5>Select Dates</h5> -->
                                                          <b-form-group label="" class="mb-0 new_date_pk manage_multiple_date_picker">
                                                             <b-input-group>
                                                                  <date-picker
                                                                    v-model="dayArrCalendar"
                                                                    multiple
                                                                    append-to=".manage_multiple_date_picker"
                                                                    popover="bottom-right"
                                                                    locale="en"
                                                                   :formatter="formatDate"
                                                                    format="DD-MM-YYYY"
                                                                    display-format="DD-MM-YYYY"
                                                                    placeholder="Select Dates"
                                                                    :class="dayArrCalendar.length > 0 ? 'hide_date_text' : 'show_date_text'"
                                                                  />
                                                                  <template v-slot:append>
                                                                    <b-button
                                                                      aria-label="Clear date"
                                                                      @click="dayArrCalendar = []"
                                                                      class="custom_close_date"
                                                                    >
                                                                      <span class="clear-btn multiple_close_btn">x</span>
                                                                    </b-button>
                                                                  </template>
                                                                </b-input-group>
                                                                <!-- {{dayArrCalendar}} -->
                                                               
                                                            <!-- <m-date-picker v-model="day" :multi="true" :always-display="false" lang="en" :format="formatDate" class="date_picker_mange_multiple"></m-date-picker> -->
                                                          </b-form-group>
                                                        </b-col>
                                                        
                                                        <b-col xl="4"  class="filter_broadcast manage_filter_multiple">
                                                          
                                                            <b-button type="button" variant="success" @click="dateFilter(0)" class="button desktop_margin_left_zero">Filter</b-button>
                                                            <b-button variant="light" @click="resetFilter()" class="desktop_margin_left_zero">Reset</b-button>
                                                          
                                                        </b-col>
                                                        <b-col xl="12" class="submit-field mt-3 mb-0" v-if="dayArrCalendar.length > 0">
                                                           <div class="manage_multiple_custom_dates form-control">
                                                            <!-- <h5>Selected Dates</h5> -->
                                                                <div class="scroll_div_multiple">
                                                                    <span  v-for="(singleDate, index) in dayArrCalendar" :key="index" class="loop_span">
                                                                        {{ singleDate }}
                                                                        <span class="remove_icon_loop" @click="removeDate(index)">✕</span>
                                                                      </span>
                                                                       
                                                                </div>
                                                              </div>
                                                        </b-col>

                                                    </b-row>

                                                </div>
                                              </div>
                                            </div>
                                          </b-card-body>
                                        </b-collapse>
                                      </b-card>
                                    </div>
                                  </div>
                                </div>
                              <!-- </div> -->
                            </div>       
                            </div>
                            </div>    
                                <div class="col-xl-12">
                                    <b-row>
                                      
                                      <b-col lg="12" md="12" class="submit-field mb-0">
                                        <h5>Manage Jobs</h5>
                                        <div class="common_input_padding">
                                          <b-form-group class="center_radio_btn_with_text mb-2">
                                              <b-form-checkbox v-model = 'form.select_all_jobs' @input="select_all_jobs_fun($event)"><strong>Select All Jobs?</strong></b-form-checkbox>
                                          </b-form-group>
                                           <div class="submit-field" v-if="form.select_all_jobs">
                                            <!-- <h5>Jobs</h5> -->
                                              <b-form-group id="input-group-8" label="" class="required mb-0">
                                                  <multiselect v-model="jobName" id="ajax" label="title" track-by="id" placeholder="Type to search job" open-direction="bottom" :multiple="isMultiple" :options="selectedJob"  :searchable="true" :clear-on-select="true" :close-on-select="false"
                                                  :allow-empty="true" @input="getData(jobName)" class="selected_text_style common_multiselect_placeholder new_multi_slec_list job_list_multi_select multiselect_border job_id_noti job_id_noti_multiple">
                                                      <span slot="noResult">No Jobs Found.</span>
                                                  </multiselect>
                                              </b-form-group>
                                          </div>
                                        </div>
                                      </b-col>
                                     
                                    </b-row>
                                    <b-row class="common_input_padding">
                                        <b-col lg="6" md="6" class="center_radio_btn_with_text">
                                            <b-form-group class="mb-2">
                                                <b-form-checkbox v-model = 'form.update_assigned_to'><strong>Update assigned to? </strong></b-form-checkbox>
                                            </b-form-group>
                                              <div v-if="form.update_assigned_to" class="submit-field">
                                                <!-- <h5>Assigned To</h5> -->
                                                  <b-form-group id="input-group-8" label="" class="required mb-0" >
                                                      <multiselect v-model="supName" id="ajax" label="full_name" track-by="id" placeholder="Type to search user" open-direction="bottom" :multiple="false" :options="selectedSupervisor"  :searchable="true" :clear-on-select="true" :close-on-select="true"
                                                      :allow-empty="true" @input="getData1(supName)" class="common_multiselect_placeholder new_multi_slec_list job_list_multi_select multiselect_border job_id_noti job_id_noti_multiple">
                                                          <span slot="noResult">No User Found.</span>
                                                      </multiselect>
                                                  </b-form-group>
                                              </div>
                                        </b-col>
                                        <b-col lg="6" md="6" class="center_radio_btn_with_text ">
                                            <b-form-group class="mb-2">
                                                <b-form-checkbox v-model = 'form.update_service_category'><strong>Update service category? </strong></b-form-checkbox>
                                            </b-form-group>
                                              <div v-if="form.update_service_category" class="submit-field">
                                              <!-- <h5>Select Category</h5> -->
                                                <b-form-group id="input-group-4" label="" class="required mb-0">
                                                    <span class="custom-dropdown">
                                                        <b-form-select v-model="form.categoryValue" @change = 'subCatg(form.categoryValue)' class="mb-0">
                                                            <option value="" >Please Select Category</option>
                                                            <option :value="categoryVal.id" v-for="categoryVal in serviceCategories">{{categoryVal.name}}</option>
                                                        </b-form-select>
                                                    </span>
                                                </b-form-group>
                                            </div>
                                        </b-col>
                                    </b-row>
                                            <b-row v-if="subCategories == 'F & B'">
                                                <b-col lg="12" md="12">
                                                    <b-form-group>
                                                        <b-form-checkbox v-model = 'form.update_hygiene_cert'><strong>Update Food Safety Certificate? </strong></b-form-checkbox>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="12" md="12" v-if="form.update_hygiene_cert">
                                                    <b-form-group>
                                                        <b-form-checkbox v-model = 'form.is_hygiene_cert_req' @input="hyiegne_cert($event)"><strong>Food Safety Certificate Required</strong></b-form-checkbox>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="12" md="12">
                                                    <b-form-group>
                                                        <b-form-checkbox v-model = 'form.update_medical_history'><strong>Update Medical History? </strong></b-form-checkbox>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="12" md="12" v-if="form.update_medical_history">
                                                    <b-form-group>
                                                        <b-form-checkbox v-model = 'form.medical_history' @input="medical_hist($event)"><strong>With No Medical History</strong></b-form-checkbox>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                            <b-row v-if="has_department == 'yes'" class="common_input_padding">
                                                <b-col lg="12" md="12">
                                                    <b-form-group class="mb-2">
                                                        <b-form-checkbox v-model = 'form.update_department'><strong>Update Department? </strong></b-form-checkbox>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="12" md="12" v-if="form.update_department" class="submit-field">
                                                  <h5>Select Department</h5>
                                                    <b-form-group id="input-group-4" label="" class="mb-0">
                                                        <span class="custom-dropdown">
                                                            <b-form-select v-model="form.department" class="mb-0">
                                                                <option value="" >Please Select Department</option>
                                                                <option :value="dl.id" v-for="dl in departmentList">{{dl.department_name | capitalize}}</option>
                                                            </b-form-select>
                                                        </span>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                            <b-row v-if="branchList.length > 0">
                                                <b-col lg="12" md="12">
                                                    <b-form-group>
                                                        <b-form-checkbox v-model = 'form.update_branch'><strong>Update Branch? </strong></b-form-checkbox>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="12" md="12" v-if="form.update_branch">
                                                    <b-form-group id="input-group-4" label="Select Branch" >
                                                        <span class="custom-dropdown">
                                                            <b-form-select v-model="form.branch">
                                                                <option value="" >Please Select Branch</option>
                                                                <option :value="br.id" v-for="br in branchList">{{br.name | capitalize}}</option>
                                                            </b-form-select>
                                                        </span>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                            <!-- <hr> -->

                                            <b-row>
                                                <b-col lg="6" md="6" class="submit-field mb-0 center_radio_btn_with_text details_with_check_box">
                                                  <h5>Update Job Details</h5>
                                                    <b-form-group class="mb-2">
                                                        <b-form-checkbox v-model = 'form.select_all_fields' @input="select_all_fields_fun($event)"><strong>Select All</strong></b-form-checkbox>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                                <!-- <hr> -->
                                            <b-row class="common_input_padding">

                                                <b-col lg="6" md="6" class="center_radio_btn_with_text">
                                                    <b-form-group class="mb-2">
                                                        <b-form-checkbox v-model = 'form.update_job_title'><strong>Job Title</strong></b-form-checkbox>
                                                    </b-form-group>
                                                     <div  v-if = 'form.update_job_title' class="submit-field">
                                                        <!-- <h5>Job Title</h5> -->
                                                          <b-form-group id="input-group-2" label="" class="required mb-0">
                                                              <b-form-textarea id="input-2" v-model="form.title" type="textarea" placeholder="" class="mb-0"></b-form-textarea>
                                                          </b-form-group>
                                                      </div>
                                                </b-col>
                                                <b-col lg="6" md="6">
                                                    <b-form-group class="mb-2">
                                                        <b-form-checkbox v-model = 'form.update_job_scope'><strong>Job Scope</strong></b-form-checkbox>
                                                    </b-form-group>
                                                    <div v-if = 'form.update_job_scope' class="submit-field">
                                                      <!-- <h5>Job Scope</h5> -->
                                                        <b-form-group id="input-group-3" label="" class="required mb-0">
                                                            <b-form-textarea id="textarea-3" class="textareaResizeMore mb-0" v-model="form.job_scope" type="textarea" :value=" form.job_scope"></b-form-textarea>
                                                        </b-form-group>
                                                    </div>
                                                </b-col>
                                            </b-row>
                                            <b-row class="common_input_padding">
                                                <b-col lg="12" md="12">
                                                    <b-form-group class="mb-2">
                                                        <b-form-checkbox v-model = 'form.update_job_requirement'><strong>Job Requirements</strong></b-form-checkbox>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="12" md="12" v-if = 'form.update_job_requirement' class="submit-field">
                                                  <!-- <h5>Job Requirements</h5> -->
                                                    <b-form-group id="input-group-3" label="" class="required mb-0">
                                                        <b-form-textarea id="textarea-3" class="textareaResizeMore mb-0" v-model="form.description" type="textarea" :value=" form.description" ></b-form-textarea>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                            <!-- <b-row> -->
                                            <b-row class="common_input_padding">
                                                <b-col lg="6" md="6">
                                                    <b-form-group class="mb-2">
                                                        <b-form-checkbox v-model = 'form.update_work_site_contact_person'><strong>Contact Person 1 Name</strong></b-form-checkbox>
                                                    </b-form-group>
                                                     <div  v-if = 'form.update_work_site_contact_person' class="submit-field">
                                                      <!-- <h5>Work Site Contact Person 1 Name</h5> -->
                                                        <b-form-group id="input-group-9" label="" class="mb-0">
                                                            <b-form-input id="input-9" v-model="work_site_contact_person" type="text" placeholder="" class="with-border mb-0"></b-form-input>
                                                        </b-form-group>
                                                    </div>
                                                </b-col>
                                                <b-col lg="6" md="6">
                                                    <b-form-group class="mb-2">
                                                        <b-form-checkbox v-model = 'form.update_work_site_contact_person_country_code'><strong>Contact Person 1 Number</strong></b-form-checkbox>
                                                    </b-form-group>
                                                    <div class="row">
                                                    <div  v-if = 'form.update_work_site_contact_person_country_code' class="submit-field col-xl-3">
                                                      <!-- <h5>Work Site Contact Person 1 Number</h5> -->
                                                        <b-form-group id="input-group-3" label="" class="contact-fields mb-0">
                                                            <span class="custom-dropdown">
                                                                <b-form-select v-model="work_site_contact_person_country_code" @change = 'onCountryCodeChange(form.personal.country_code)' class="mb-0" >
                                                                    <option value="">Code</option>
                                                                    <option :value="country.country_code" v-for="country in countries">{{country.country_code}}</option>
                                                                </b-form-select>
                                                            </span>
                                                          
                                                        </b-form-group>
                                                    </div>
                                                    <div class="col-xl-9 submit-field" v-if = 'form.update_work_site_contact_person_country_code'>
                                                       <!-- <h5 class="hidden_h5">Work Site Contact Person 1 Number</h5> -->
                                                        <b-form-input id="input-8" type="text" placeholder="" class="with-border mb-0" v-model="work_site_contact_person_mobile_no"></b-form-input>
                                                    </div>
                                                    </div>
                                                </b-col>
                                            </b-row>
                                           
                                            <!-- </b-row> -->
                                            <!-- <b-row> -->
                                              <b-row class="common_input_padding">
                                                <b-col lg="6" md="6">
                                                    <b-form-group class="mb-2">
                                                        <b-form-checkbox v-model = 'form.update_work_site_contact_person_2'><strong>Contact Person 2 Name</strong></b-form-checkbox>
                                                    </b-form-group>
                                                        <div  v-if = 'form.update_work_site_contact_person_2' class="submit-field">
                                                            <!-- <h5>Work Site Contact Person 2 Name</h5> -->
                                                              <b-form-group id="input-group-9" label="" class="mb-0">
                                                                  <b-form-input id="input-9" v-model="work_site_contact_person_2" type="text" placeholder="" class="with-border mb-0"></b-form-input>
                                                              </b-form-group>
                                                          </div>
                                                </b-col>
                                                <b-col lg="6" md="6">
                                                    <b-form-group class="mb-2">
                                                        <b-form-checkbox v-model = 'form.update_work_site_contact_person_2_country_code'><strong>Contact Person 2 Number</strong></b-form-checkbox>
                                                    </b-form-group>
                                                    <div class="row">
                                                     <div v-if = 'form.update_work_site_contact_person_2_country_code' class="submit-field col-xl-3">
                                                        <!-- <h5>Work Site Contact Person 2 Number</h5> -->
                                                          <b-form-group id="input-group-3" label="" class="contact-fields mb-0">
                                                              <span class="custom-dropdown">
                                                                  <b-form-select class="mb-0" v-model="work_site_contact_person_2_country_code" @change = 'onCountryCodeChange(form.personal.country_code)'  >
                                                                      <option value="">Code</option>
                                                                      <option :value="country.country_code" v-for="country in countries">{{country.country_code}}</option>
                                                                  </b-form-select>
                                                              </span>
                                                          </b-form-group>
                                                      </div>
                                                      <div class="col-xl-9 submit-field" v-if = 'form.update_work_site_contact_person_2_country_code'>
                                                          <!-- <h5 class="hidden_h5">Work Site Contact Person 2 Number</h5> -->
                                                          <b-form-input id="input-8" type="text" placeholder="" v-model="work_site_contact_person_2_mobile_no" class="mb-0 with-border"></b-form-input>
                                                      </div>
                                                    </div>
                                                </b-col>
                                              </b-row>
                                            <!-- </b-row> -->
                                            <b-row class="common_input_padding">
                                                <b-col lg="12" md="12" class="">
                                                    <b-form-group class="mb-2">
                                                        <b-form-checkbox v-model = 'form.update_remarks'><strong>Remarks</strong></b-form-checkbox>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="12" md="12" v-if = 'form.update_remarks' class="submit-field">
                                                    <!-- <h5>Remarks(Internal use)</h5> -->
                                                    <b-form-group id="input-group-3" label="" class="mb-0">
                                                        <b-form-textarea id="textarea-4" v-model="form.remarks" type="textarea" class="mb-0"></b-form-textarea>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                            <b-row class="common_input_padding">
                                                <b-col lg="6" md="6">
                                                    <b-form-group class="mb-2">
                                                        <b-form-checkbox v-model = 'form.update_start_time'><strong>Start Time</strong></b-form-checkbox>
                                                    </b-form-group>
                                                    <div v-if = 'form.update_start_time' class="start_time_new submit-field" >
                                                      <!-- <h5>Start Time</h5> -->
                                                        <b-form-group id="input-group-7" label="" class="required mb-0">
                                                            <vue-timepicker format="hh:mm A" v-model="form.starttime" @input = 'computeWorkingHours' class="common_input_field  common_time_picker scheduled_min desktop_margin_bottom_zero "></vue-timepicker>
                                                            <!-- <span class="input-icon"><b-img v-bind:src="webUrl+ '/images/clock-grey-icon02.svg'" alt="Clock Icon"></b-img></span> -->
                                                        </b-form-group>
                                                    </div>
                                                </b-col>
                                                  <b-col lg="6" md="6">
                                                    <b-form-group class="mb-2">
                                                        <b-form-checkbox v-model = 'form.update_hours'><strong>No of Hours</strong></b-form-checkbox>
                                                    </b-form-group>
                                                    <b-row class="">
                                                      <b-col lg="6" md="6"  v-if = 'form.update_hours' class="submit-field">
                                                    <!-- <h5>No. Of Hours</h5> -->
                                                      <b-form-group id="input-group-4" label="" class="required mb-0">
                                                      
                                                          <span class="custom-dropdown">
                                                              <b-form-select v-model="form.hours" class="mb-0">
                                                                  <option value="" disabled="true">Please Select No. of Hours</option>
                                                                  <option :value="arr" v-for="arr in working_hours_arr">{{arr}}</option>
                                                              </b-form-select>
                                                          </span>
                                                      </b-form-group>
                                                      </b-col>
                                                      <b-col lg="6" md="6" v-if = 'form.update_hours' class="submit-field">
                                                          <!-- <h5>No. of Minutes</h5> -->
                                                            <b-form-group id="input-group-4" label="" class="required mb-0">
                                                            
                                                                <span class="custom-dropdown">
                                                                    <b-form-select v-model="form.working_minutes" class="mb-0">
                                                                        <option value="" disabled="true">Please Select No. of Minutes</option>
                                                                        <option :value="arr" v-for="arr in working_minutes_arr">{{arr}}</option>
                                                                    </b-form-select>
                                                                </span>
                                                            </b-form-group>
                                                      </b-col>
                                                    </b-row>
                                                </b-col>
                                            </b-row>
                                            <b-row class="common_input_padding">
                                                <b-col lg="6" md="6">
                                                    <b-form-group class="mb-2">
                                                        <b-form-checkbox v-model = 'form.update_vacancy'><strong>Vacancy</strong></b-form-checkbox>
                                                    </b-form-group>
                                                    <div v-if = 'form.update_vacancy' class="submit-field">
                                                      <!-- <h5>Vacancy</h5> -->
                                                        <b-form-group id="input-group-9"  label="" class="required mb-0">
                                                            <b-form-input id="input-9" maxlength="6" v-model="form.vacancy" type="text" placeholder="" class="with-border mb-0"></b-form-input>
                                                        </b-form-group>
                                                    </div>
                                                </b-col>
                                                 <b-col lg="6" md="6">
                                                    <b-form-group class="mb-2">
                                                        <b-form-checkbox v-model = 'form.update_true_vacancy'><strong>True Vacancy</strong></b-form-checkbox>
                                                    </b-form-group>
                                                    <div  v-if = 'form.update_true_vacancy' class="submit-field">
                                                      <!-- <h5>True Vacancy</h5> -->
                                                        <b-form-group id="input-group-9"  label="" class="required mb-0">
                                                            <b-form-input id="input-9" maxlength="6" v-model="form.true_vacancy" type="text" placeholder="" class="mb-0 with-border"></b-form-input>
                                                        </b-form-group>
                                                    </div>
                                                </b-col>

                                                <!-- <b-col lg="1" md="1" v-if = 'form.update_vacancy' class="submit-field">
                                                </b-col> -->

                                                
                                                
                                                <!-- <b-col lg="1" md="1" v-if = 'form.update_vacancy'>
                                                </b-col> -->

                                                <!-- <b-col lg="6" md="6" v-if = 'form.update_vacancy' class="submit-field">
                                                  <h5>Reset Vacancy Status?</h5>
                                                    <b-form-group id="input-group-8" label="" class="category-radio required mb-0 text_with_redio_in_single_line " >
                                                        <b-form-radio v-model="form.reset_vacancy_status" name="reset_vacancy_status" value="yes">Yes</b-form-radio>
                                                        <b-form-radio v-model="form.reset_vacancy_status" name="reset_vacancy_status" value="no">No</b-form-radio>
                                                    </b-form-group>
                                                </b-col> -->
                                            </b-row>
                                            <b-row class="common_input_padding">
                                               
                                                
                                                <!-- <b-col lg="5" md="5" v-if = 'form.update_true_vacancy'>
                                                </b-col> -->
                                                
                                            <!-- </b-row> -->
                                            <!-- <b-row > -->
                                                <b-col lg="6" md="6">
                                                    <b-form-group class="mb-2">
                                                        <b-form-checkbox v-model = 'form.update_per_hour_cost'><strong>Per Hour Cost</strong></b-form-checkbox>
                                                    </b-form-group>
                                                     <div v-if = 'form.update_per_hour_cost' class="submit-field">
                                                      <!-- <h5>Select Per Hour Cost</h5> -->
                                                        <b-form-group id="input-group-4" label="" class="required mb-0">
                                                            <span class="custom-dropdown">
                                                                <b-form-select v-model="form.price" @change = 'getCostList' class="mb-0">
                                                                    <option value="" disabled="true">Please Select Per Hour Cost</option>
                                                                    <option :value="cost.per_hour_cost" v-for="cost in costListing">{{cost.per_hour_cost}}</option>
                                                                </b-form-select>
                                                            </span>
                                                        </b-form-group>
                                                    </div>
                                                </b-col>
                                                 <b-col lg="6" md="6" class="">
                                                    <b-form-group class="mb-2">
                                                        <!-- <b-form-checkbox v-model = 'form.update_platform_fee'><strong>Update {{platform_fee_title}}</strong></b-form-checkbox> -->
                                                        <b-form-checkbox v-model = 'form.update_platform_fee'><strong>Fixed Fee</strong></b-form-checkbox>
                                                    </b-form-group>
                                                     <div v-if="form.status == 'active' && form.update_platform_fee" class="submit-field">
                                                      <!-- <h5>{{platform_fee_title}}</h5> -->
                                                        <b-form-group id="input-group-9"  class="required mb-0">
                                                            <b-form-input id="input-9" maxlength="6" v-model="form.platform_fee" type="text" placeholder="" class="with-border mb-0"></b-form-input>
                                                        </b-form-group>
                                                    </div>
                                                </b-col>
                                            </b-row>
                                            <b-row >
                                               
                                            </b-row>
                                            
                                            
                                </div>
                                <div class="col-xl-12">
                                  <p class="red-text manage_multiple_red_p">
                                    <!-- <strong> -->
                                      Optional Details
                                      <!-- </strong> -->
                                  </p>
                                                    <!-- <hr> -->
                                </div>
                                <div class="col-xl-12">
                                  <b-row class="common_input_padding">
                                      <!-- <b-col lg="12" md="12">
                                          <b-form-group class="mb-2">
                                              <b-form-checkbox v-model = 'form.update_is_ot'><strong>Update Is OT Job? </strong></b-form-checkbox>
                                          </b-form-group>
                                      </b-col> -->
                                      <b-col lg="6" md="6">
                                          <div class="permission_listing">
                                              <b-form-group class="mb-2">
                                                  <b-form-checkbox value="yes" unchecked-value="no" v-model="form.is_ot"><strong>Is OT Job?</strong></b-form-checkbox>
                                              </b-form-group>
                                          </div>
                                      </b-col>
                                       <b-col lg="6" md="6">
                                          <div class="permission_listing">
                                              <b-form-group class="mb-2">
                                                  <b-form-checkbox value="yes" unchecked-value="no" v-model="form.is_perm_partime"><strong>Is Permanent Part Time job?</strong></b-form-checkbox>
                                              </b-form-group>
                                          </div>
                                      </b-col>
                                      <!-- <b-col lg="12" md="12" >
                                          <b-form-group class="mb-2">
                                              <b-form-checkbox v-model = 'form.update_is_perm_partime'><strong>Update Is Permanent Part Time job? </strong></b-form-checkbox>
                                          </b-form-group>
                                      </b-col> -->
                                     
                                      <!-- <b-col lg="12" md="12">
                                          <b-form-group class="mb-2">
                                              <b-form-checkbox v-model = 'form.update_location_instructions'><strong>Update Pictorial Instructions? </strong></b-form-checkbox>
                                          </b-form-group>
                                      </b-col> -->
                                      <b-col lg="3" md="3">
                                          <b-form-group class="mb-2">
                                              <b-form-checkbox value="yes" unchecked-value="no" v-model = 'instruction_images' @input="instruction_img($event)"><strong>Update Pictorial Instructions?</strong></b-form-checkbox>
                                          </b-form-group>
                                      </b-col>
                                      <b-col lg="4" md="4" v-if="instruction_images == 'yes'">
                                          <p class="mb-0"><b-link @click="showImagesModal()">Select / View Pictorial Instructions</b-link></p>
                                      </b-col>
                                  </b-row>
                                </div>

                                <!-- <div class="col-xl-12" >
                                  <b-form-group class="mb-2">
                                      <b-form-checkbox v-model = 'form.update_lunch_pay'><strong>Update Lunch Pay? </strong></b-form-checkbox>
                                  </b-form-group>
                                </div> -->
                                <div class="col-xl-12">
                                  <div class="permission_listing common_input_padding">
                                      <b-form-group class="mb-2">
                                          <b-form-checkbox value="yes" unchecked-value="no" v-model="lunch_pay_not_provided"><strong>Update Unpaid break</strong></b-form-checkbox>
                                      </b-form-group>
                                  </div>
                                </div>
                                <div class=" col-xl-6 col-md-6 submit-field" v-if="form.update_lunch_pay && (lunch_pay_not_provided == 'yes')">
                                  <!-- <h5>No. Of Hours</h5> -->
                                  <b-form-group id="input-group-4" label="" class="required mb-0 common_input_padding">     
                                        <span class="custom-dropdown"> 
                                            <b-form-select v-model="form.lunch_pay_hours" class="mb-0">
                                                <option value="" disabled="true">Please Select No. of Hours</option>
                                                <option :value="arr" v-for="arr in lunch_hours_arr">{{arr}}</option>
                                            </b-form-select>
                                        </span>
                                    </b-form-group>
                                </div>
                                <div class="col-xl-12">
                                  <p class="red-text manage_multiple_red_p">
                                    <!-- <strong> -->
                                      FL Requirements (Optional)
                                      <!-- </strong> -->
                                    </p>
                                                    <!-- <hr> -->
                                </div>
                                <!-- <b-row> -->
                                  <div class="col-xl-12">
                                    <b-row class="common_input_padding">
                                      <div class="col-xl-6">
                                        <b-form-group class="mb-2">
                                          <b-form-checkbox value="yes" unchecked-value="no" v-model="form.update_gender"><strong>Update Gender</strong></b-form-checkbox>
                                      </b-form-group>
                                      <div class="submit-field" v-if="form.update_gender == 'yes'">
                                        <!-- <h5>Gender</h5> -->
                                        <b-form-group id="input-group-4" label="" class="mb-0">
                                              <span class="custom-dropdown">
                                                  <b-form-select v-model="form.gender" class="mb-0">
                                                      <option :value="null" disabled="true">Please Select Gender</option>
                                                      <option value="female">Female</option>
                                                      <option value="male" selected>Male</option>
                                                  </b-form-select>
                                              </span>
                                          </b-form-group>
                                      </div>
                                      </div>
                                    
                                      <div class="col-xl-6">
                                        <b-form-group class="mb-2">
                                          <b-form-checkbox value="yes" unchecked-value="no" v-model="form.update_age_range"><strong>Update Age Range</strong></b-form-checkbox>
                                        </b-form-group>
                                      <div class="submit-field" v-if="form.update_age_range == 'yes'">
                                        <!-- <h5>Age Range</h5> -->
                                        <b-form-group id="input-group-9" label="" class="mb-0">
                                            <!-- <b-form-input id="input-9" v-model="form.age_cap" type="number" min="15" max="70" placeholder=""></b-form-input> -->
                                            <div class="row">
                                              <div class="col-xl-6 col-md-6">
                                                <b-form-input id="input-6" v-model="form.min_age" type="number" min="15" max="70" placeholder="Min Age" class="with-border mb-0"></b-form-input>
                                              </div>
                                              <div class="col-xl-6 col-md-6">
                                                <b-form-input id="input-6" v-model="form.max_age" type="number" min="15" max="70" placeholder="Max Age" class="with-border mb-0"></b-form-input>
                                              </div>
                                            </div>
                                        </b-form-group>
                                      </div>
                                      </div>
                                    </b-row>
                                  </div>
                                <!-- </b-row> -->
                                <div class="col-xl-12">
                                  <b-row class="common_input_padding">
                                        <b-col lg="6" md="6">
                                            <b-form-group class="mb-2">
                                                <b-form-checkbox v-model = 'form.update_address'><strong>Update Address</strong></b-form-checkbox>
                                            </b-form-group>
                                              <div v-if = 'form.update_address' class="submit-field">
                                                <!-- <h5>Address</h5> -->
                                                  <b-form-group id="input-group-2" label="" class="common_input_field  location-input-field required mb-0">
                                                      <gmap-autocomplete
                                                      @place_changed="setPlace"
                                                      style="width: 1000px"
                                                      placeholder="Please type for suggestions"
                                                      @click="addMarker"
                                                      :options="autocompleteOptions"
                                                      :value="form.addressValueData"
                                                    >
                                                    </gmap-autocomplete>
                                                  </b-form-group>
                                              </div>
                                        </b-col>
                                         <b-col lg="6" md="6">
                                          <b-form-group class="mb-2">
                                              <b-form-checkbox v-model = 'form.update_unit'><strong>Update Unit</strong></b-form-checkbox>
                                          </b-form-group>
                                          <div v-if="form.update_unit" class="submit-field">
                                            <!-- <h5>Unit No.(Optional)</h5> -->
                                              <b-form-group id="input-group-2" label="" class="mb-0">
                                                  <b-form-input id="input-2" v-model="form.unit" type="text" placeholder="" class="with-border mb-0"></b-form-input>
                                              </b-form-group>
                                          </div>
                                      </b-col>
                                                
                                    </b-row>
                                            <!-- <h4 class="mb-2"></h4> -->
                                          
                                            <b-row>
                                                <b-col lg="6" md="6">
                                                    <div class="form-map-box">
                                                        <gmap-map
                                                            :center="center"
                                                            :zoom="12"
                                                            style="width:100%;  height: 400px;"
                                                            >
                                                            <gmap-marker
                                                            :draggable="false"
                                                            :key="index"
                                                            v-for="(m, index) in markers"
                                                            :position="m.position"
                                                            @click="center=m.position"
                                                            ></gmap-marker>
                                                            </gmap-map>
                                                    
                                                    </div>
                                                    <!-- @dragend="showLocation" -->
                                                </b-col>
                                            </b-row>
                                </div>
                                          
                            </div>
                            
                            
                        </b-form>
                         <div class="edit_form_box_manage_multiple">
                          <div slot="footer" class="form-btn mt-3 margin-top-30">
                              <b-button type="button" variant="success" @click="formSubmit()" class="desktop_margin_left_zero">Submit</b-button>
                              <b-button :to="{name:'dp-jobs', params: { from:this.$route.params.from} }" variant="light" class="ml-2 desktop_margin_right_zero" style="background-color: black;">Cancel</b-button>
                          </div>
                        </div>
                        </div>
                       
                    <!-- </div> -->
                    
                    </b-tab>
  
                    <b-tab
                      :title="'Add Applicants'"
                      @click="clear"
                      class=""
                    >
                    <!-- <div class="row"> -->
                    <div class="dashboard-box mt-0 center_radio_btn_with_text common_padding_20">
                        <b-form method="post" id="add-applicants-form" class="nw_frm ">
                            <div class="row">
                                <!-- <div class="col-xl-12"> -->
                                <!-- <div class="dashboard-box desktop_margin_top_zero"> -->
                                    <!-- <div class="col-xl-12 cat_inner_divs w-100"> -->
                                        <div class="col-xl-12 submit-field error_submit_field ">
                                        <h5>Company Name<span class="required_star">*</span></h5>
                                        <multiselect
                                            v-model="companyName"
                                            id="ajax"
                                            label="name"
                                            track-by="id"
                                            placeholder="Search by keyword"
                                            open-direction="bottom"
                                            :options="selectedCompany"
                                            :searchable="true"
                                            :clear-on-select="true"
                                            :close-on-select="true"
                                            :allow-empty="true"
                                            @input="onCompanyChange(companyName,0)"
                                            class="common_multiselect_placeholder new_multi_slec_list job_list_multi_select multiselect_border job_id_noti job_id_noti_multiple"
                                        >
                                            <span slot="noResult">No Company Found.</span>
                                        </multiselect>
                                        </div>
                                    <!-- </div> -->
                                <!-- </div>   -->
                            <!-- </div> -->
                            <div class="col-xl-12">
                              <div class="">
                              <div class="single_accordian broadcast_faq_new mb-3 mt-1">
                              <!-- <br> -->
                              <div>
                                <div class="faq-content-box clearfix">
                                  <div>
                                    <div class="accordion-listing-box ">
                                      <b-card no-body>
                                        <b-card-header header-tag="header" role="tab">
                                          <b-button
                                            v-b-toggle="
                                              'accordion_add_multiple_job'
                                            "
                                            class="m-1"
                                            variant="info"
                                          >
                                            <div class="dashboard-box">
                                              <div class="headline">
                                                <h3 class="red_option">Optional Filters</h3>
                                              </div>
                                            </div>
                                          </b-button>
                                        </b-card-header>
                                        <b-collapse
                                          :id="'accordion_add_multiple_job'"
                                          role="tabpanel"
                                        >
                                          <b-card-body>
                                            <div class="">
                                              <div class="row">
                                                <div class="col-xl-12">
                                                  <b-row>
                                                      <b-col xl="4"  class="search_by_keyword_manage_multple submit-field admin_listing_search new_search_div_daily_job">
                                                        <!-- <h5>Search by keyword</h5> -->
                                                        <div class="search-box custom_search_admin desktop_margin_top_zero"> 
                                                          <!-- <b-form-group label=""> -->
                                                           <b-input-group-prepend>
                                                            <!-- <b-input-group> -->
                                                              <b-form-input
                                                                id="searchBtn1"
                                                                v-model="searchKeyword1"
                                                                placeholder="Search by keyword"
                                                                v-on:keyup.enter="dateFilter(1)"
                                                                class="with-border"
                                                              ></b-form-input>
                                                              <!-- <b-input-group-append> -->
                                                                <b-button class="btn points_events" @click="dateFilter(1)">
                                                                  <i class="fa fa-search"></i>
                                                                </b-button>
                                                              <!-- </b-input-group-append> -->
                                                            <!-- </b-input-group> -->
                                                           </b-input-group-prepend>
                                                          <!-- </b-form-group> -->
                                                        </div>
                                                      </b-col>

                                                      <b-col xl="8" class="submit_field_big_screen_and_mobile ">
                                                        <!-- <h5>Address</h5> -->
                                                          <b-form-group id="input-group-8" label="" class="mb-0">
                                                              <multiselect v-model="address" id="ajax" label="address" track-by="id"  placeholder="Type to search address" open-direction="bottom" :multiple="isMultiple" :options="selectedAddress"  :searchable="true" :clear-on-select="false" :close-on-select="false" 
                                                              :allow-empty="true" @close="dateFilter(1)" class="common_multiselect_placeholder new_multi_slec_list job_list_multi_select multiselect_border">
                                                                  <span slot="noResult">No Address Found.</span>
                                                              </multiselect>
                                                          </b-form-group>
                                                      </b-col>
                                                      <b-col xl="4" class="submit_field_big_screen_and_mobile">
                                                      <!-- <h5>Start Time</h5> -->
                                                        <b-form-group label="" class="mb-0">
                                                          <multiselect v-model="time" id="ajax" label="start_time" track-by="id" placeholder="Select start time" open-direction="bottom" :multiple="isMultiple" :options="selectedTime" :searchable="true" :clear-on-select="false" :close-on-select="false" :allow-empty="true" @close="dateFilter(1)" class="common_multiselect_placeholder new_multi_slec_list job_list_multi_select multiselect_border">
                                                            <span slot="noResult">No Start Time Found.</span>
                                                          </multiselect>
                                                        </b-form-group>
                                                      </b-col>

                                                      <b-col xl="4" class="submit_field_big_screen_and_mobile">
                                                        <!-- <h5>Select Dates</h5> -->
                                                        <b-form-group label="" class="mb-0 new_date_pk manage_multiple_date_picker" id="add_applicants_date">
                                                          <b-input-group>
                                                                  <date-picker
                                                                    v-model="dayArrCalendar"
                                                                    multiple
                                                                    append-to="#add_applicants_date"
                                                                    popover="bottom-right"
                                                                    locale="en"
                                                                   :formatter="formatDate"
                                                                    format="DD-MM-YYYY"
                                                                    display-format="DD-MM-YYYY"
                                                                    placeholder="Select Dates"
                                                                    :class="dayArrCalendar.length > 0 ? 'hide_date_text' : 'show_date_text'"
                                                                  />
                                                                  <template v-slot:append>
                                                                    <b-button
                                                                      aria-label="Clear date"
                                                                      @click="dayArrCalendar = []"
                                                                      class="custom_close_date"
                                                                    >
                                                                      <span class="clear-btn multiple_close_btn">x</span>
                                                                    </b-button>
                                                                  </template>
                                                                </b-input-group>
                                                          <!-- <m-date-picker v-model="day" :multi="true" :always-display="false" lang="en" :format="formatDate" class="date_picker_mange_multiple"></m-date-picker> -->
                                                        </b-form-group>
                                                      </b-col>
                                                        
                                                      <b-col xl="4"  class="filter_broadcast manage_filter_multiple">
                                                          <b-button type="button" variant="success" @click="dateFilter(1)" class="button desktop_margin_left_zero ">Filter</b-button>
                                                          <b-button variant="light" @click="resetFilter()" class="desktop_margin_left_zero ">Reset</b-button>
                                                      </b-col>
                                                      <b-col xl="12" class="submit-field mt-3 mb-0" v-if="dayArrCalendar.length > 0">
                                                           <div class="manage_multiple_custom_dates form-control">
                                                            <!-- <h5>Selected Dates</h5> -->
                                                                <div class="scroll_div_multiple">
                                                                    <span  v-for="(singleDate, index) in dayArrCalendar" :key="index" class="loop_span">
                                                                        {{ singleDate }}
                                                                        <span class="remove_icon_loop" @click="removeDate(index)">✕</span>
                                                                      </span>
                                                                </div>
                                                              </div>
                                                        </b-col>

                                            </b-row>

                                                </div>
                                              </div>
                                            </div>
                                          </b-card-body>
                                        </b-collapse>
                                      </b-card>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>       
                            </div>
                            </div>    
                                <!-- <div class="col-xl-12 submit-field"> -->
                                    <!-- <b-row> -->
                                      <b-col lg="12" md="12" class="submit-field">
                                          <div class="clearfix  calender_div_job_in_job dash_last_div">
                                            <h5>Date Range:</h5>
                                              <b-form-group id="input-group-6" label="" class="required mb-0">
                                                  <date-range-picker ref="picker" :minDate="minDate" :opens="cent" :locale-data="locale" :auto-apply="auto" v-model="dateRange" :ranges='range' @update="dateFilter(0)" class="manage_multiple_admin_date_range common_date_range_picker_for_v2">
                                                      <div slot="input" slot-scope="picker">
                                                          {{ picker.startDate | date }} - {{ picker.endDate | date }}
                                                      </div>
                                                  </date-range-picker>
                                              </b-form-group>
                                          </div>
                                      </b-col>
                                      <b-col lg="6" md="6">
                                          <b-form-group class="mb-2">
                                              <b-form-checkbox v-model = 'form.select_all_jobs' @input="select_all_jobs_fun($event)"><strong>Select All Jobs?</strong></b-form-checkbox>
                                          </b-form-group>
                                      </b-col>
                                      <b-col lg="12" md="12" class="submit-field">
                                        <h5>Jobs</h5>
                                          <b-form-group id="input-group-8" label="" class="required mb-0">
                                              <multiselect v-model="jobName" id="ajax" label="title" track-by="id" placeholder="Type to search job" open-direction="bottom" :multiple="isMultiple" :options="selectedJob"  :searchable="true" :clear-on-select="true" :close-on-select="false"
                                              :allow-empty="true" @input="getData(jobName)" class="selected_text_style common_multiselect_placeholder new_multi_slec_list job_list_multi_select multiselect_border job_id_noti job_id_noti_multiple">
                                                  <span slot="noResult">No Jobs Found.</span>
                                              </multiselect>
                                          </b-form-group>
                                      </b-col>
                                    <!-- </b-row> -->
                                <!-- </div> -->
                                <div class="col-xl-12">
                                  <b-row>
                                      <b-col lg="12" md="12" class="submit-field">
                                        <h5>FL List</h5>
                                        <b-form-group id="input-group-8" label="" class="required mb-0">
                                                <multiselect @input="getData2(flName)" v-model="flName" id="ajax" label="fl_name" track-by="id" placeholder="Type to search freelancer" open-direction="bottom" :options="selectedFl" :multiple="true" :loading="isLoading" :internal-search="false" :clear-on-select="false" :close-on-select="false" :options-limit="300" @search-change="asyncFind" :searchable="true" class="common_multiselect_placeholder new_multi_slec_list job_list_multi_select multiselect_border job_id_noti job_id_noti_multiple">
                                                    <span slot="noResult">No User Found.</span>
                                                </multiselect>
                                            </b-form-group>
                                        </b-col>
                                        <b-col lg="12" md="12" class="submit-field mb-0">
                                          <h5>Select Option </h5>
                                            <b-form-group id="input-group-8" label="" class="mb-0 category-radio required text_with_redio_in_single_line">
                                                <b-form-radio v-model="add_with" name="add_with" value="as_applicant">As Applicant</b-form-radio>
                                                <b-form-radio v-model="add_with" name="add_with" value="as_selected">As Selected</b-form-radio>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                </div>            
                            </div>
                            
                            
                        </b-form>
                        <div class="edit_form_box_manage_multiple">
                          <div slot="footer" class="form-btn mt-3 margin-top-30">
                              <b-button type="button" variant="success" @click="addFl()" class="desktop_margin_left_zero">Submit</b-button>
                              <b-button :to="{name:'dp-jobs', params: { from:this.$route.params.from} }" variant="light" class="ml-2 desktop_margin_right_zero" style="background-color: black;">Cancel</b-button>
                          </div>
                        </div>
                      </div>
                       
                    <!-- </div> -->
                    </b-tab>
                    

                    <b-tab
                      :title="'Cancel Jobs'"
                      @click="clear"
                      class=""
                    >
                    <!-- <div class="row"> -->
                    <div class="dashboard-box mt-0 center_radio_btn_with_text common_padding_20">
                        <b-form method="post" id="add-applicants-form" class="nw_frm ">
                            <div class="row">
                                <!-- <div class="col-xl-12"> -->
                                <!-- <div class="dashboard-box desktop_margin_top_zero"> -->
                                    <div class="col-xl-12">
                                        <div class="submit-field error_submit_field ">
                                        <h5>Company Name<span class="required_star">*</span></h5>
                                        <multiselect
                                            v-model="companyName"
                                            id="ajax"
                                            label="name"
                                            track-by="id"
                                            placeholder="Search by keyword"
                                            open-direction="bottom"
                                            :options="selectedCompany"
                                            :searchable="true"
                                            :clear-on-select="true"
                                            :close-on-select="true"
                                            :allow-empty="true"
                                            @input="onCompanyChange(companyName,2)"
                                            class="common_multiselect_placeholder new_multi_slec_list job_list_multi_select multiselect_border job_id_noti job_id_noti_multiple"
                                        >
                                            <span slot="noResult">No Company Found.</span>
                                        </multiselect>
                                        </div>
                                    </div>
                                <!-- </div>   -->
                            <!-- </div> -->
                            <div class="col-xl-12">
                              <div class="">
                              <div class="single_accordian broadcast_faq_new mb-3 mt-1">
                              <!-- <br> -->
                              <div>
                                <div class="faq-content-box clearfix">
                                  <div>
                                    <div class="accordion-listing-box ">
                                      <b-card no-body>
                                        <b-card-header header-tag="header" role="tab">
                                          <b-button
                                            v-b-toggle="
                                              'accordion_cancel_multiple_job'
                                            "
                                            class="m-1"
                                            variant="info"
                                          >
                                            <div class="dashboard-box">
                                              <div class="headline">
                                                <h3 class="red_option">Optional Filters</h3>
                                              </div>
                                            </div>
                                          </b-button>
                                        </b-card-header>
                                        <b-collapse
                                          :id="'accordion_cancel_multiple_job'"
                                          role="tabpanel"
                                        >
                                          <b-card-body>
                                            <div class="">
                                              <div class="row">
                                                <div class="col-xl-12">
                                                  <b-row>
                                                      <b-col lg="4" class="submit-field search_by_keyword_manage_multple submit-field admin_listing_search new_search_div_daily_job ">
                                                        <!-- <h5>Search by keyword</h5> -->
                                                        <!-- <b-form-group label=""> -->
                                                          <!-- <b-input-group> -->
                                                          <div class="search-box custom_search_admin desktop_margin_top_zero">
                                                           <b-input-group-prepend>
                                                            <b-form-input
                                                              id="searchBtn2"
                                                              v-model="searchKeyword2"
                                                              placeholder="Search by keyword"
                                                              v-on:keyup.enter="dateFilter(2)"
                                                              class="with-border mb-0"
                                                            ></b-form-input>
                                                            <!-- <b-input-group-append> -->
                                                              <b-button class="btn points_events" @click="dateFilter(2)">
                                                                <i class="fa fa-search"></i>
                                                              </b-button>
                                                            <!-- </b-input-group-append> -->
                                                             </b-input-group-prepend>
                                                          </div>
                                                          <!-- </b-input-group> -->
                                                        <!-- </b-form-group> -->
                                                      </b-col>

                                                      <b-col lg="4" class="submit-field">
                                                        <!-- <h5>Address</h5> -->
                                                          <b-form-group id="input-group-8" label="" class="mb-0">
                                                              <multiselect v-model="address" id="ajax" label="address" track-by="id"  placeholder="Type to search address" open-direction="bottom" :multiple="isMultiple" :options="selectedAddress"  :searchable="true" :clear-on-select="false" :close-on-select="false" 
                                                              :allow-empty="true" @close="dateFilter(2)" class="common_multiselect_placeholder new_multi_slec_list job_list_multi_select multiselect_border">
                                                                  <span slot="noResult">No Address Found.</span>
                                                              </multiselect>
                                                          </b-form-group>
                                                      </b-col>
                                                      <b-col lg="4" class="submit-field">
                                                        <!-- <h5>From Date</h5> -->
                                                          <b-form-group id="input-group-7" label="" class="required calender_z_index_9 calender_in_mobile mb-0">
                                                              <datepicker v-model="date" :disabled-dates="disabledFromDate2" placeholder="Enter a date to filter from" @input="dateFilter(2)" class="from_date_manage_multiple add_calender_icon new_add_calender_icon"></datepicker>
                                                          </b-form-group>
                                                      </b-col>
                                                      <b-col lg="4" class="submit-field">
                                                        <!-- <h5>Start Time</h5> -->
                                                          <b-form-group label="" class="mb-0">
                                                            <multiselect v-model="time" id="ajax" label="start_time" track-by="id" placeholder="Select start time" open-direction="bottom" :multiple="isMultiple" :options="selectedTime" :searchable="true" :clear-on-select="false" :close-on-select="false" :allow-empty="true" @close="dateFilter(2)" class="common_multiselect_placeholder new_multi_slec_list job_list_multi_select multiselect_border">
                                                              <span slot="noResult">No Start Time Found.</span>
                                                            </multiselect>
                                                          </b-form-group>
                                                      </b-col>

                                                      <b-col lg="4" class="submit-field">
                                                        <!-- <h5>Select Dates</h5> -->
                                                        <b-form-group label="" class="mb-0 new_date_pk manage_multiple_date_picker" id="cancel_job_date">
                                                          <b-input-group>
                                                                  <date-picker
                                                                    v-model="dayArrCalendar"
                                                                    multiple
                                                                    append-to="#cancel_job_date"
                                                                    popover="bottom-right"
                                                                    locale="en"
                                                                   :formatter="formatDate"
                                                                    format="DD-MM-YYYY"
                                                                    display-format="DD-MM-YYYY"
                                                                    placeholder="Select Dates"
                                                                    :class="dayArrCalendar.length > 0 ? 'hide_date_text' : 'show_date_text'"
                                                                  />
                                                                  <template v-slot:append>
                                                                    <b-button
                                                                      aria-label="Clear date"
                                                                      @click="dayArrCalendar = []"
                                                                      class="custom_close_date"
                                                                    >
                                                                      <span class="clear-btn multiple_close_btn">x</span>
                                                                    </b-button>
                                                                  </template>
                                                                </b-input-group>
                                                          <!-- <m-date-picker v-model="day" :multi="true" :always-display="false" lang="en" :format="formatDate" class="date_picker_mange_multiple"></m-date-picker> -->
                                                        </b-form-group>
                                                      </b-col>
                                                       
                                                      <b-col lg="4" md="12" class="filter_broadcast manage_filter_multiple">
                                                        
                                                          <b-button type="button" variant="success" @click="dateFilter(2)" class="button desktop_margin_left_zero ">Filter</b-button>
                                                          <b-button variant="light" @click="resetFilter()" class="desktop_margin_left_zero ">Reset</b-button>
                                                        
                                                      </b-col>
                                                      <b-col xl="12" class="submit-field" v-if="dayArrCalendar.length > 0">
                                                           <div class="manage_multiple_custom_dates form-control">
                                                            <!-- <h5>Selected Dates</h5> -->
                                                                <div class="scroll_div_multiple">
                                                                    <span  v-for="(singleDate, index) in dayArrCalendar" :key="index" class="loop_span">
                                                                        {{ singleDate }}
                                                                        <span class="remove_icon_loop" @click="removeDate(index)">✕</span>
                                                                      </span>
                                                                </div>
                                                              </div>
                                                        </b-col>

                                                    </b-row>

                                                </div>
                                              </div>
                                            </div>
                                          </b-card-body>
                                        </b-collapse>
                                      </b-card>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>       
                            </div>
                            </div>    
                                <div class="col-xl-12">
                                    <b-row>
                                      
                                      <b-col lg="6" md="6">
                                          <b-form-group class="mb-2">
                                              <b-form-checkbox v-model = 'form.select_all_jobs' @input="select_all_jobs_fun($event)"><strong>Select All Jobs?</strong></b-form-checkbox>
                                          </b-form-group>
                                      </b-col>
                                      <b-col lg="12" md="12" class="submit-field">
                                        <h5>Jobs</h5>
                                          <b-form-group id="input-group-8" label="" class="required mb-0">
                                              <multiselect v-model="jobName" id="ajax" label="title" track-by="id" placeholder="Type to search job" open-direction="bottom" :multiple="isMultiple" :options="selectedJob"  :searchable="true" :clear-on-select="true" :close-on-select="false"
                                              :allow-empty="true" @input="getData(jobName)" class="selected_text_style common_multiselect_placeholder new_multi_slec_list job_list_multi_select multiselect_border job_id_noti job_id_noti_multiple">
                                                  <span slot="noResult">No Jobs Found.</span>
                                              </multiselect>
                                          </b-form-group>
                                      </b-col>
                                      
                                    </b-row>
                                    <b-row>
                                        <b-col lg="12" md="12" class="submit-field  mb-0">
                                          <h5>Cancellation Reason</h5>
                                            <b-form-group id="input-group-8" label="" class="required mb-0" >
                                                <b-form-textarea id="textarea-3" class="textareaResizeMore with-border mb-0" v-model="cancellation_reason" type="textarea"  ></b-form-textarea>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                </div>     
                            </div>
                            
                        </b-form>
                        <div class="edit_form_box_manage_multiple">
                          <div slot="footer" class="form-btn mt-3 margin-top-30">
                                <b-button type="button" variant="success" @click="cancelJobs()" class="desktop_margin_left_zero">Submit</b-button>
                                <b-button :to="{name:'dp-jobs', params: { from:this.$route.params.from} }" variant="light" class="ml-2 desktop_margin_right_zero" style="background-color: black;">Cancel</b-button>
                            </div>
                        </div>
                        </div>
                        
                    <!-- </div> -->

                    </b-tab>
                    <b-tab
                      :title="'Cancel/Withdraw Applicants'"
                      @click="getFlList('cancel_applicant')"
                      class=""
                    >
                    <!-- <div class="row"> -->
                        <div class="dashboard-box mt-0 center_radio_btn_with_text common_padding_20">
                            <b-form method="post" id="add-applicants-form" class="nw_frm ">
                                <div class="row">  
                                    <div class="col-xl-12">
                                      <b-row>
                                          <b-col lg="12" md="12" class="submit-field">
                                            <h5>FL List</h5>
                                          <b-form-group id="input-group-8" label="" class="required mb-0" >
                                                  <multiselect v-model="flName" id="ajax" label="full_name" track-by="id" placeholder="Type to search user" open-direction="bottom" :multiple="false" :options="selectedFl"  :searchable="true" :clear-on-select="true" :close-on-select="true"
                                                  :allow-empty="true" @change="onApplicantChange()" class="common_multiselect_placeholder common_multiselect_placeholder new_multi_slec_list job_list_multi_select multiselect_border job_id_noti job_id_noti_multiple">
                                                      <span slot="noResult">No User Found.</span>
                                                  </multiselect>
                                              </b-form-group>
                                          </b-col>
                                          <b-col lg="12" md="12" class="submit-field">
                                            <h5>Select Option </h5>
                                              <b-form-group id="input-group-8" label="" class="mb-0 category-radio required new_input_group text_with_redio_in_single_line">
                                                  <b-form-radio v-model="withdraw_type" name="withdraw_type" value="withdraw" @input="onApplicantChange(flName)" >Withdraw Applicant</b-form-radio>
                                                  <b-form-radio v-model="withdraw_type" name="withdraw_type" value="cancel" @input="onApplicantChange(flName)">Cancel Awarded Applicant</b-form-radio>
                                              </b-form-group>
                                          </b-col>
                                      </b-row>
                                    </div>
                                    <div class="col-xl-12">
                                        <b-row>
                                          
                                          <b-col lg="6" md="6">
                                              <b-form-group class="">
                                                  <b-form-checkbox v-model = 'form.select_all_jobs' @input="select_all_jobs_fun($event)"><strong>Select All Jobs?</strong></b-form-checkbox>
                                              </b-form-group>
                                          </b-col>
                                          <b-col lg="12" md="12" class="submit-field">
                                            <h5>Jobs</h5>
                                              <b-form-group id="input-group-8" label="" class="required mb-0">
                                                  <multiselect v-model="jobName" id="ajax" label="title" track-by="id" placeholder="Type to search job" open-direction="bottom" :multiple="isMultiple" :options="selectedJob"  :searchable="true" :clear-on-select="true" :close-on-select="false"
                                                  :allow-empty="true" @input="getData(jobName)" class="selected_text_style common_multiselect_placeholder new_multi_slec_list job_list_multi_select multiselect_border job_id_noti job_id_noti_multiple">
                                                      <span slot="noResult">No Jobs Found.</span>
                                                  </multiselect>
                                              </b-form-group>
                                          </b-col>
                                          
                                        </b-row>
                                        <b-row>
                                              <b-col lg="12" md="12" class="submit-field mt-0">
                                                <h5>Cancellation Reason</h5>
                                                  <b-form-group id="input-group-8" label="" class="required mb-0" >
                                                      <b-form-textarea id="textarea-3" class="textareaResizeMore with-border mb-0" v-model="cancellation_reason" type="textarea"  ></b-form-textarea>
                                                  </b-form-group>
                                              </b-col>
                                          </b-row>
                                    </div>
                                              
                                </div>
                                
                                
                            </b-form>
                             <div class="edit_form_box_manage_multiple">
                                <div slot="footer" class="form-btn mt-3 margin-top-30">
                                      <b-button type="button" variant="success" @click="cancelApplicants()" class="desktop_margin_left_zero">Submit</b-button>
                                      <b-button :to="{name:'dp-jobs', params: { from:this.$route.params.from} }" variant="light" class="ml-2 desktop_margin_right_zero" style="background-color: black;">Cancel</b-button>
                                </div>
                              </div>
                        </div>
                    <!-- </div> -->
                    </b-tab>
                    <b-tab
                      :title="'Add Back/Revive Applicants'"
                      @click="getFlList('revival')"
                      class=""
                    >
                    <!-- <div class="row"> -->
                          <div class="dashboard-box mt-0 center_radio_btn_with_text common_padding_20">
                              <b-form method="post" id="add-applicants-form" class="nw_frm ">
                                  <div class="row">  
                                      <!-- <div class="col-xl-12"> -->
                                        <!-- <b-row> -->
                                            <b-col lg="12" md="12" class="submit-field">
                                              <h5>FL List</h5>
                                            <b-form-group id="input-group-8" label="" class="required mb-0" >
                                                    <multiselect v-model="flName" id="ajax" label="fl_name" track-by="id" placeholder="Type to search user" open-direction="bottom" :multiple="false" :options="selectedFl"  :searchable="true" :clear-on-select="true" :close-on-select="true"
                                                    :allow-empty="true" @change="onApplicantChange('revive')" class="common_multiselect_placeholder new_multi_slec_list job_list_multi_select multiselect_border job_id_noti job_id_noti_multiple">
                                                        <span slot="noResult">No User Found.</span>
                                                    </multiselect>
                                                </b-form-group>
                                            </b-col>
                                            <b-col lg="12" md="12" class="submit-field">
                                              <h5>Revive As</h5>
                                              <b-form-group id="input-group-8" label="" class="mb-0 text_with_redio_in_single_line category-radio required new_input_group">
                                                  <b-form-radio v-model="add_type" name="add_type" value="as_applicant" >As Applicant</b-form-radio>
                                                  <b-form-radio v-model="add_type" name="add_type" value="as_selected" >As Awarded</b-form-radio>
                                              </b-form-group>
                                            </b-col>
                                            <b-col lg="12" md="12" class="submit-field mt-0">
                                              <h5>Select Option</h5>
                                                <b-form-group id="input-group-8" label=" " class="mb-0 text_with_redio_in_single_line category-radio required new_input_group">
                                                    
                                                    <b-form-radio v-model="revive_with" name="revive_with" value="withdraw" @input="onApplicantChange('revive')" >Withdrawn Jobs</b-form-radio>
                                                    <b-form-radio v-model="revive_with" name="revive_with" value="cancel" @input="onApplicantChange('revive')">Cancelled Jobs</b-form-radio>
                                                </b-form-group>
                                            </b-col>
                                        <!-- </b-row> -->
                                      <!-- </div> -->
                                      <div class="col-xl-12">
                                          <b-row>
                                            
                                            <b-col lg="6" md="6">
                                                <b-form-group class="mb-2">
                                                    <b-form-checkbox v-model = 'form.select_all_jobs' @input="select_all_jobs_fun($event)"><strong>Select All Jobs?</strong></b-form-checkbox>
                                                </b-form-group>
                                            </b-col>
                                            <b-col lg="12" md="12" class="submit-field mb-0">
                                              <h5>Jobs</h5>
                                                <b-form-group id="input-group-8" label="" class="required mb-0">
                                                    <multiselect v-model="jobName" id="ajax" label="title" track-by="id" placeholder="Type to search job" open-direction="bottom" :multiple="isMultiple" :options="selectedJob"  :searchable="true" :clear-on-select="true" :close-on-select="false"
                                                    :allow-empty="true" @input="getData(jobName)" class="selected_text_style common_multiselect_placeholder new_multi_slec_list job_list_multi_select multiselect_border job_id_noti job_id_noti_multiple">
                                                        <span slot="noResult">No Jobs Found.</span>
                                                    </multiselect>
                                                </b-form-group>
                                            </b-col>
                                            
                                          </b-row>
                                          
                                      </div>
                                                
                                  </div>
                                  
                                  
                              </b-form>
                               <div class="edit_form_box_manage_multiple">
                                  <div slot="footer" class="form-btn mt-3 margin-top-30">
                                    <b-button type="button" variant="success" @click="reviveApplicants()" class="desktop_margin_left_zero">Submit</b-button>
                                    <b-button :to="{name:'dp-jobs', params: { from:this.$route.params.from} }" variant="light" class="ml-2 desktop_margin_right_zero" style="background-color: black;">Cancel</b-button>
                                  </div>
                                </div>
                            </div>
                    <!-- </div> -->
                    </b-tab>
                    <b-tab
                      :title="'Exports'"
                      @click="clear"
                      class=""
                    >
                    <!-- <div class="row"> -->
                    <div class="dashboard-box mt-0 center_radio_btn_with_text common_padding_20">
                        <b-form method="post" id="add-applicants-form" class="nw_frm ">
                            <div class="row">  
                                <!-- <div class="col-xl-12"> -->
                                  <!-- <b-row> -->
                                    <b-col lg="12" md="12" class="submit-field">
                                      <h5>Company Name<span class="required_star">*</span></h5>
                                        <b-form-group id="input-group-8" label="" class="required mb-0" v-if="form.jobFor == 'forcompany'">
                                            <multiselect v-model="companyName" id="ajax" label="name" track-by="id" placeholder="Search by keyword" open-direction="bottom" :options="selectedCompany" :multiple="false"  :searchable="true" :clear-on-select="true" :close-on-select="true" :value="companyName" :allow-empty="true" @input="onCompanyChange(companyName,0)" class="common_multiselect_placeholder new_multi_slec_list job_list_multi_select multiselect_border job_id_noti job_id_noti_multiple">
                                                <span slot="noResult">No Company Found.</span>
                                            </multiselect>
                                        </b-form-group>
                                    </b-col>
                                      <b-col lg="12" md="12" class="submit-field">
                                        <h5>Data Format</h5>
                                          <b-form-group id="input-group-8" label="" class="mb-0 text_with_redio_in_single_line category-radio required new_input_group">
                                              <b-form-radio v-model="data_format" name="data_format" value="simple_data" >Simple Data</b-form-radio>
                                              <b-form-radio v-model="data_format" name="data_format" value="full_data" >Full Data</b-form-radio>
                                          </b-form-group>
                                      </b-col>
                                      <b-col lg="12" md="12" class="submit-field mb-0">
                                        <h5>Job Date</h5>
                                          <b-form-group id="input-group-7" label="" class="mb-0 required calender_z_index_9 calender_in_mobile">
                                              <datepicker v-model="job_date" class="exports_from_date_manage_multiple"></datepicker>
                                              <!-- <span class="input-icon"><b-img :src="webUrl+ '/images/calendar-grey-icon02.svg'" alt="Calander Icon"></b-img></span> -->
                                          </b-form-group>
                                      </b-col>
                                  <!-- </b-row> -->
                                <!-- </div> -->
                                          
                            </div>
                            
                            
                        </b-form>
                         <div class="edit_form_box_manage_multiple">
                            <div slot="footer" class="form-btn mt-3 margin-top-30">
                                  <b-button type="button" variant="success" @click="downloadList()" class="desktop_margin_left_zero">Submit</b-button>
                                  <b-button :to="{name:'dp-jobs', params: { from:this.$route.params.from} }" variant="light" class="ml-2 desktop_margin_right_zero" style="background-color: black;">Cancel</b-button>
                            </div>
                        </div>
                    </div>
                    <!-- </div> -->
                    </b-tab>
                    <b-tab
                      :title="'Award Badge to Applicants'"
                      @click="getFlList('add_applicant', true)"
                      class=""
                    >
                        <div class="dashboard-box mt-0 center_radio_btn_with_text common_padding_20">
                            <b-form method="post" id="award-badge-form" class="nw_frm ">
                                <div class="row">  
                                    <!-- <div class="col-xl-12"> -->
                                      <!-- <b-row> -->
                                                    
                                            <b-col lg="12" md="12" class="submit-field">
                                              <h5>Badges</h5>
                                                <b-form-group id="input-group-8" label="" class="mb-0 required" >
                                                    <multiselect v-model="badgeName" id="ajax" label="name" track-by="id" placeholder="Type to search badge" open-direction="bottom" :multiple="true" :options="badgeList"  :searchable="true" :clear-on-select="true" :close-on-select="false"
                                                    :allow-empty="true" class="common_multiselect_placeholder new_multi_slec_list job_list_multi_select multiselect_border job_id_noti job_id_noti_multiple">
                                                        <span slot="noResult">No Badge Found.</span>
                                                    </multiselect>
                                                </b-form-group>
                                            </b-col>
                                        <!-- </b-row> -->
                                        <!-- <b-row> -->
                                            <b-col lg="12" md="12" class="submit-field">
                                              <h5>Company Name<span class="required_star">*</span></h5>
                                            <b-form-group id="input-group-8" label="" class="mb-0 required" v-if="form.jobFor == 'forcompany'">
                                                <multiselect v-model="companyName" id="ajax" label="name" track-by="id" placeholder="Search by keyword" open-direction="bottom" :options="selectedCompany" :multiple="true"  :searchable="true" :clear-on-select="true" :close-on-select="true" :value="companyName" :allow-empty="true" @input="onCompanyChange(companyName,0)" class="common_multiselect_placeholder new_multi_slec_list job_list_multi_select multiselect_border job_id_noti job_id_noti_multiple">
                                                    <span slot="noResult">No Company Found.</span>
                                                </multiselect>
                                            </b-form-group>
                                            </b-col>
                                        <!-- </b-row> -->
                                        <!-- <b-row> -->
                                            <b-col lg="12" md="12" class="submit-field">
                                              <h5>FL List</h5>
                                                <b-form-group id="input-group-8" label="" class="mb-0 required" >
                                                    <multiselect v-model="flName" id="ajax" label="fl_name" track-by="id" placeholder="Type to search freelancer" open-direction="bottom" :options="selectedFl" :multiple="true" :loading="isLoading" :internal-search="false" :clear-on-select="false" :close-on-select="false" :options-limit="300" @search-change="asyncFind" :searchable="true" class="common_multiselect_placeholder new_multi_slec_list job_list_multi_select multiselect_border job_id_noti job_id_noti_multiple">
                                                        <span slot="noResult">No User Found.</span>
                                                    </multiselect>
                                                </b-form-group>
                                            </b-col>
                                            
                                            <b-col lg="12" md="12" class="submit-field mb-0">
                                              <h5>Remarks</h5>
                                                <b-form-group id="input-group-3" label="" class="mb-0">
                                                    <b-form-textarea id="textarea-4" v-model="badge_remarks" type="textarea" class="with-border mb-0"></b-form-textarea>
                                                </b-form-group>
                                            </b-col>
                                        <!-- </b-row> -->
                                    <!-- </div> -->
                                              
                                </div>
                            </b-form>
                            <div class="edit_form_box_manage_multiple">
                              <div slot="footer" class="form-btn mt-3 margin-top-30">
                                  <b-button type="button" variant="success" @click="awardBadge()" class="desktop_margin_left_zero">Submit</b-button>
                                  <b-button :to="{name:'dp-jobs', params: { from:this.$route.params.from} }" variant="light" class="ml-2 desktop_margin_rigth_zero" style="background-color: black;">Cancel</b-button>
                              </div>
                          </div>
                        </div>
                    </b-tab>
                    <b-tab
                      :title="'Export Insurance List'"
                      @click="clear"
                      v-if="show('multiple_jobs_export_insurance_list')"
                    >
                     <div class="dashboard-box mt-0 center_radio_btn_with_text common_padding_20">
                        <b-form method="post" id="award-badge-form" class="nw_frm ">
                            <div class="row">  
                                <!-- <div class="col-xl-12"> -->
                                  <!-- <b-row> -->
                                      <b-col lg="12" md="12" class="submit-field">
                                          <div class="clearfix  calender_div_job_in_job dash_last_div">
                                            <h5>Date Range:</h5>
                                              <b-form-group id="input-group-6" label="" class="required mb-0">
                                                  <date-range-picker ref="picker" :minDate="minDate" :opens="cent" :locale-data="locale" :auto-apply="auto" v-model="dateRange" :ranges='range' class="manage_multiple_admin_date_range common_date_range_picker_for_v2">
                                                      <div slot="input" slot-scope="picker">
                                                          {{ picker.startDate | date }} - {{ picker.endDate | date }}
                                                      </div>
                                                  </date-range-picker>
                                              </b-form-group>
                                          </div>
                                      </b-col>
                                      <b-col lg="12" md="12" class="submit-field mb-0">
                                        <h5>Data Format</h5>
                                          <b-form-group id="input-group-8" label="" class="text_with_redio_in_single_line mb-0 category-radio required new_input_group">
                                              <b-form-radio v-model="insurance_data_format" name="insurance_data_format" value="old_format" >Old Format</b-form-radio>
                                              <b-form-radio v-model="insurance_data_format" name="insurance_data_format" value="new_format" >New Format</b-form-radio>
                                          </b-form-group>
                                      </b-col>
                                  <!-- </b-row> -->
                                <!-- </div> -->
                                          
                            </div>
                            
                      
                        </b-form>
                        <div class="edit_form_box_manage_multiple">
                            <div slot="footer" class="form-btn mt-3 margin-top-30">
                                <b-button type="button" variant="success" @click="insuredFlList()" class="desktop_margin_left_zero">Submit</b-button>
                                <b-button :to="{name:'dp-jobs', params: { from:this.$route.params.from} }" variant="light" class="ml-2 desktop_margin_right_zero" style="background-color: black;">Cancel</b-button>
                            </div>
                          </div>
                     </div>
                    </b-tab>
                  </b-tabs>
                </div>
              </div>
            </div>
          </div>


          <!-- <div class="margin-top-70"></div> -->
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { POST_API, GET_API } from "../../../store/actions.type";
  import Multiselect from "vue-multiselect";
  import VueSingleSelect from "vue-single-select";
  import moment from "moment";
  import DateRangePicker from "vue2-daterange-picker";
  import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
  import JwtService from "../../../common/jwt.service";
  import StarRating from "vue-star-rating";
  import { BTooltip } from "bootstrap-vue";
  import Datepicker from "vuejs-datepicker";
  
  import Vue from "vue";
  import VueQRCodeComponent from "vue-qrcode-component";
  import Bus from "../../../event-bus";
  import VueTimepicker from "vuejs-timepicker";
  import VuePersianDatetimePicker from "vue-persian-datetime-picker";
  
  export default {
    data() {
       const date = new Date();
      const isoDate = date.toISOString().split("T")[0];
      const [year, month, day] = isoDate.split("-");
      const formattedDate = `${day}-${month}-${year}`;
      return {
        dayArrCalendar:[],
        formattedDate,
        companyName: "",
        selectedCompany: [],
        searchKeyword1: '',
        searchKeyword: '',
        searchKeyword2: '',
        time:'',
            address:'',
            date:'',
            day:[],
            jobName:'',
            flName:'',
            dateArr:[],
            isMultiple : true,
            selectedSupervisor:[],
            selectedJob:[],
            selectedTime:[],
            selectedAddress:[],
            selectedDate:[],
            selectedFl:[],
            badge_remarks:'',
            badgeName:'',
            work_site_contact_person:'',
            work_site_contact_person_country_code:'+65',
            work_site_contact_person_mobile_no:'',
            work_site_contact_person_2:'',
            work_site_contact_person_2_country_code:'+65',
            work_site_contact_person_2_mobile_no:'',
            countries:[],
            job_date: moment().format('YYYY-MM-DD'),
            has_department:'no',
            branchList:[],
            disabled_select_all_jobs:false,
            working_minutes_arr:['00', '15', '30', '45'],
            working_hours_arr:[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
            lunch_hours_arr:[0.25, 0.5, 0.75, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5],
            autocompleteOptions: {
                componentRestrictions: {
                  country: [
                    'SG'
                  ],
                },
            },
            // address:'',
            items: null,
            dataItem:null,
            datas:'',
            serviceCategories: [],
            categories:'',
            categoryVal:'',
            checkboxVal:'',
            category_id:'',
            service_id: [],
            sub_service_id: [],
            subCategories: [],
            departmentList:[],
            subvalue: [],
            checkedValue:'',
            companyAddress:'',
            supName:'',
            sup:'',
            selectedFl:[],
            fl_id: [],
        dropdownState: 'closed', // Track the dropdown state
        cancellation_reason:'',
        charge_type: "",
        mwList: [],
        selectedSupervisor: [],
        suspention_reason: "",
        job_start_time: {
          hh: "09",
          mm: "33",
          A: "AM",
        },
        job_end_time: {
          hh: "00",
          mm: "00",
          A: "AM",
        },
        disabledFromDate1: {
          from: new Date(Date.now() + 3600 * 1000 * 24),
        },
        qrcode: "",
        job_start_date: "",
        job_end_date: "",
        lunch_pay_not_provided: "no",
        job_cancellation_reason: "",
        lunch_pay_hours: "",
        jobDatas: [],
        skill: "",
        daily: "",
        full_time: "",
        extended_hours: "",
        extension_rate: "",
        min: "",
        location: "",
        remarks: "",
        type: "",
        keyword: "",
        regen: "generate_ts",
        generateTitle: "Generate TS",
        withNoEmail: "no",
        cancellation_reason: "",
        salary: "",
        error_message: "",
        skillsArr: [],
        tagArr: [],
        value: [0, 15000],
        pager: {},
        pageOfItems: [],
        options: [],
        items: null,
        totalRows: 0,
        sliderValue: 50,
        costListing: [],
        from: "",
        to: "",
        currentPage: 1,
        perPage: 25,
        pageOptions: [25, 50, 75, 100],
        keyVal: 0,
        inprogress: true,
        upcoming: false,
        moreinfo: [],
        completed: false,
        cancelled: false,
        all: false,
        selected: true,
        application: false,
        system_withdrawn: false,
        applicant_withdrawn: false,
        rate_review: false,
        review1: "",
        activeCount: "",
        shortlistedCount: "",
        hiredCount: "",
        rejectedCount: "",
        allCount: "",
        remaining_feature_jobs: 0,
        loading: false,
        webUrl: process.env.VUE_APP_URL,
        webServerUrl: process.env.VUE_APP_SERVER_URL,
        webUrlV1: process.env.VUE_APP_URL_V1,
        webUrlManageJob: process.env.VUE_APP_URL,
        userDatas: "",
        selectedsup: [],
        supervisorName: "",
        selectedSupervisor: [],
    
  
        checkedStar: [],
        sortBy: null,
        acStatus: "",
        sortDirection: "asc",
        lunch_break: "no",
        filter: "",
        status: "active",
        sortDesc: true,
        range: false,
        date: moment().format('YYYY-MM-DD'),
        format: "YYYY-MM-DD HH:mm",
        auto: true,
        center: "center",
        cent: 'center',
        minDate: null,
        locale: {
          direction: "ltr", //direction of text
          format: "DD-MMM-YYYY", //fomart of the dates displayed
          separator: " - ", //separator between the two ranges
          applyLabel: "Apply",
          cancelLabel: "Cancel",
          /*weekLabel: 'W',
                  customRangeLabel: 'Custom Range',*/
          daysOfWeek: moment.weekdaysMin(), //array of days - see moment documenations for details
          monthNames: moment.monthsShort(), //array of month names - see moment documenations for details
          firstDay: 0, //ISO first day of week - see moment documenations for details
          sameDateFormat: {
            from: "DD MM YYYY, hh:mm",
            to: "hh:mm",
          },
        },
        latlongMarkers: [],
        infoContent: "",
        infoWindowPos: {
          lat: 0,
          lng: 0,
        },
        infoWinOpen: false,
        currentMidx: null,
        fullscreenControl: false,
        infoOptions: {
          pixelOffset: {
            width: 0,
            height: -35,
          },
        },
        MarkerOptions: {
          zIndex: 999999,
          opacity: 0.2,
        },
        timePicker24Hour: true,
        timePicker: true,
        dateInput: {
          placeholder: "Select Date",
        },
        dismissCountDown: 0,
        countDownChanged: "",
        calendarTimeInput: {
          readonly: true,
          step: 30,
          inputClass: "my_custom_class",
        },
        rating: 0,
        addDays: moment().add("3", "days").format("YYYY-MM-DD h:m:s"),
        readOnly: true,
        dateRange: {
          startDate: "",
          endDate: "",
        },
        start_date_filter: "",
        end_date_filter: "",
        filterSearch: "",
        filterServiceCategory: null,
        qr_title: "",
        inprogressCount: 0,
        upcomingCount: 0,
        vacancySet: 0,
        applicant_cancellation_reason: "",
        permissionActions: "",
        allManageJobDPLocal: [],
        extended_min: 0,
        filterSearchSelected: "",
        default_increment_in_vacancy: 0,
        selectedTab: "",
        arrival_condition: "",
        arrival_time: "",
        user_revived_with: "",
        arrival_model_title: "",
  
        disabledSuspend: false,
        disabledSuspendNp: false,
        insurance_future_required: "no",
  
        // fields: [
        //   { key: "image_title", label: "Banner Title", sortable: true },
        //   { key: "image_description", label: "Banner Description", sortable: true },
        //   { key: "status", label: "Status", sortable: true },
        //   { key: "toggleAction", label: "Actions" },
        // ],
  
        items: "",
        status: "in-progress",
        serviceCategories: [],
        allCompanies: [],
        statusCompanies: [],
        companiesVal: "",
        company_id: "",
        currentActiveTab: "",
        company_url: "",
        screenWidth: 0,
        user_jobs_remark: "",
        moreInfo: "",
        notify_fl: "",
        is_extension: "",
        weburl: "",
        not_suitable_reason: "",
  
        disabledFromDate: "",
  
        modify_time: "",
        arrival_time_next_day: "",
        job_url: "",
        companyId: "",
        itemsData: "",
        totalRows: 1,
        perPage: 25,
        pageOptions: [25, 50, 75, 100],
        sortBy: null,
        sortDirection: "asc",
        qrcode: "",
        qr_title: "",
  
        qr_job_id: "",
        qr_url: "",
        error_message: "",
        countDownChanged: "",
        dismissCountDown: "",
        // status: 'active',
        isBusy: false,
        sortBy: "",
        sortDesc: false,
        sortDirection: "asc",
        to: "",
        from: "",
        selectedSupervisor: [],
        supervisorName: "",
        selected_supervisor_id: "",
        selected_company_id: "",
        company_id: "",
        userType: "",
        webUrl: process.env.MIX_APP_URL,
        v2WebUrl: process.env.MIX_APP_URL_V2,
  
        inprogress: true,
        upcoming: false,
        completed: false,
        cancelled: false,
        all: false,
  
        from: this.$route.params.from,
        actions: "",
        user_type_id: "",
        link: null,
        user_id: "",
        servicesFilter: "",
        companiesFilter: "",
        start_date: "",
        end_date: "",
        dateRange: {
          startDate: "",
          endDate: "",
        },
  
        range: false,
        date: moment().format("YYYY-MM-DD"),
        format: "YYYY-MM-DD HH:mm",
        auto: true,
        center: "center",
        minDate: null,
        locale: {
          direction: "ltr", //direction of text
          format: "DD-MMM-YYYY", //fomart of the dates displayed
          separator: " - ", //separator between the two ranges
          applyLabel: "Apply",
          cancelLabel: "Cancel",
          /*weekLabel: 'W',
                  customRangeLabel: 'Custom Range',*/
          daysOfWeek: moment.weekdaysMin(), //array of days - see moment documenations for details
          monthNames: moment.monthsShort(), //array of month names - see moment documenations for details
          firstDay: 0, //ISO first day of week - see moment documenations for details
          sameDateFormat: {
            from: "DD MM YYYY, hh:mm",
            to: "hh:mm",
          },
        },
        disabledFromDate2: {
            to: new Date(Date.now() - 86400000)
           },
        timePicker24Hour: true,
        timePicker: true,
        dateInput: {
          placeholder: "Select Date",
        },
        calendarTimeInput: {
          readonly: true,
          step: 30,
          inputClass: "my_custom_class",
        },
        readOnly: true,
        checkedValue: [],
        tabIndex: 1,
        tabs: ["#1", "#2", "#3", "#4"],
        notif_title: "",
        notif_description: "",
        instruction_images : 'no',
        broadcast_job_id: "",
        share_job_id: "",
        share_service_id: "0",
        share_company_id: "",
        share_company_name: "",
        keyword_url: "",
        search: "",
        broadcast_date: "",
        broadcast_time: "",
        withNoEmail: "no",
        generateTs: false,
        generateSr: true,
        sr_generate_for_job: "",
        fulltime_remarks: "",
        working_minutes_arr: ["00", "15", "30", "45"],
        vacancy: "",
        price: "",
        working_hours: "",
        job_time: "after",
        working_minutes: "",
        lunch_pay_hours: "",
        title: "",
        lunch_pay_not_provided: "no",
        mwList: [],
        mwSearch: "",
        isLoading: false,
        selected_mw: [],
        selected_mw_arr: "",
        is_perm_partime: "no",
        disabledBtn: false,
        selectedUser: [],
        selectAll: false,
        ot_type: "view",
        ot_jobs_array: [],
        ot_key: "",
        billable: "",
        billing_type: "",
        amount: 0,
        remarks: "",
        internal_remarks: "",
        tr_type: "in-progress",
        editable_item: "",
        billing_types: [],
        billable_name: "",
        fl_type: "",
        designation: "",
        break_type: "add",
        selectAllCompleted: [],
        platform_fee_title: "",
        platform_fee: "",
        isLoading:false,
        add_with:'as_applicant',
        insurance_opted:'no',
        withdraw_type:'',
            add_type:'as_selected',
            revive_with:'',
            applicantJobList:[],
            form: {
                title: '',
                addressValueData:"",
                // description:'\n1)*Arrival Instruction*\nReporting location: At the front gate \nPlease call Supervisor when arrived at job site. Mark your arrival too.\n\n 2)*Dress Code* \n Long black pants/jeans with covered shoes \n\n 3)*Others* \n Bring NRIC for verification ',
                // job_scope:'\n1)\n\n2)\n',
                description:'',
                job_scope:'',
                remarks:'',
                address:'',
                startdate:'',
                category_id:'',
                unit:'',
                working_hour:'',
                working_minutes: '00',
                jobFor:'forcompany',
                categoryValue:'',
                formattedAddress:'',
                vacancy:'',
                true_vacancy:'',
                reset_vacancy_status: 'no',
                price:'',
                platform_fee:0,
                hours:'',
                onDemandCheck:'false',
                is_hygiene_cert_req: false,
                medical_history: false,
                department:'',
                branch:'',
                cpf_not_paid: 'no',
                yourFormat: 'hh:mm A',
                
                starttime: {
                hh: 'hh',
                mm: 'mm',
                A: 'AM'
                
                },
                endtime: {
                hh: '00',
                mm: '00',
                AM: 'AM'
                
                },
                lunch_pay_hours: 0.5,
                is_ot:'no',
                is_perm_partime:'no',
                race_id:null,
                gender:null,
                min_age:'',
                max_age:'',
                status:'',
                update_job_title:false,
                update_job_scope:false,
                update_job_requirement:false,
                update_work_site_contact_person:false,
                update_work_site_contact_person_country_code:false,
                update_work_site_contact_person_mobile_number:false,
                update_work_site_contact_person_2:false,
                update_work_site_contact_person_2_country_code:false,
                update_work_site_contact_person_2_mobile_number:false,
                update_remarks:false,
                update_start_time:false,
                update_hours:false,
                update_per_hour_cost:false,
                update_platform_fee:false,
                update_vacancy:false,
                update_true_vacancy:false,
                update_address:false,
                select_all_jobs:false,
                select_all_fields:false,
                update_location_instructions:false,
                update_lunch_pay:false,
                update_service_category:false,
                update_unit:false,
                update_assigned_to:false,
                update_hygiene_cert:false,
                update_medical_history:false,
                update_is_ot:false,
                update_is_perm_partime:false,
                update_age_range:false,
                update_gender:false,
                update_department:false,
                update_branch:false,

            },
            markers: [],
            places: [],
            success_message:'',
            badgeList:[],
            data_format:'simple_data',
            insurance_data_format:'new_format',
      };
    },
    components: {
      Multiselect,
      VueSingleSelect,
      DateRangePicker,
      Datepicker,
      StarRating,
      VueQRCodeComponent,
      BTooltip,
      VueTimepicker,
      datePicker: VuePersianDatetimePicker,
    },
    filters: {
      moment: function (date) {
        return moment(date).format("DD MMM YYYY");
      },
      removeUnderscore: function (value) {
        var i = "";
  
        if (value != null) {
          var v = value.replace("_", " ");
          v = v.toString();
          i = v.charAt(0).toUpperCase() + v.slice(1);
          return i;
        } else {
          return value;
        }
      },
      moment_1: function (date) {
        return moment(date).format("ddd DD MMM YYYY");
      },
      date: function(value) {
              if (value == null) {
                  return '';
              } else {
  
                  return moment(value).format('DD MMM YYYY')
              }
          },
      capitalize: function (value) {
        if (!value) return "";
        value = value.toString();
        return value.charAt(0).toUpperCase() + value.slice(1);
      },
      capitalizeAll: function (value) {
        if (!value) return "";
        value = value.toString();
        return value.toUpperCase();
      },
      customFormatterOne(date) {
        return moment(date).utc().format("DD MMM YYYY hh:mm A");
      },
  
      customFormatterOnecreated(date) {
        return moment(date).utc().format("DD MMM YYYY hh:mm A");
      },
      applicantOriginalSET: function (date) {
        if (date == "" || date == null) {
          return "";
        } else {
          return moment(date, "HH:mm:ss").format("hh:mm A");
        }
      },
  
      applicantOriginalSET1: function (date) {
        if (date == "" || date == null) {
          return "";
        } else {
          return moment(date).utc().format("DD MMM YYYY hh:mm A");
        }
      },
      applicantStartEndTime: function (date) {
        if (date == "" || date == null) {
          return "";
        } else {
          return moment(date, "HH:mm:ss").format("hh:mm A");
        }
      },
  
      applicantStartEndTime1: function (date) {
        if (date == "") {
          return "";
        } else {
          return moment(date, "HH:mm:ss").format("hh:mm A");
        }
      },
      jobStartEndTime: function (date) {
        if (date == "" || date == null) {
          return "";
        } else {
          return moment(date, "HH:mm:ss").format("hh:mm A");
        }
      },
      datePicker1: function (value) {
        if (value == null) {
          return "";
        } else {
          return moment(value).format("DD MMM YYYY");
        }
      },
    },
  
    methods: {
      removeDate(index) {
        this.dayArrCalendar.splice(index, 1);
      },
      onDropdownShow() {
        this.dropdownState = 'open';
      },
      computeWorkingHours(){
           var sh = !isNaN(parseInt(this.form.starttime.hh)) ? parseInt(this.form.starttime.hh*60) : 0;
           var sm = !isNaN(parseInt(this.form.starttime.mm)) ? parseInt(this.form.starttime.mm) : 0;
           var sr = sh+sm;

           var eh = !isNaN(parseInt(this.form.endtime.hh)) ? parseInt(this.form.endtime.hh*60) : 0;
           var em = !isNaN(parseInt(this.form.endtime.mm)) ? parseInt(this.form.endtime.mm) : 0;

            var er = eh+em;
        },
        onCountryCodeChange(country) {
            this.form.country_id = country;
            if (country) {
                return this.$store.dispatch(POST_API, {
                        data: { code: country },
                        api: '/api/get-country-id/' + country,
                    })
                    .then(() => {
                        if (this.$store.getters.containsErrors) {
                            this.error_message = this.$store.getters.getErrors;
                            this.showAlert();
                        } else {

                            this.form.country_id = this.$store.getters.getResults.data.id;
                            return this.form.country_id;
                        }
                    });
            }
        },
      getDepartments(id) {
            // console.log(moment().subtract(16, 'years').format('DD-MM-YYYY'));
            return this.$store.dispatch(POST_API, {
                    data:{
                        id:id
                    },
                    api: '/api/company-department-list'
                })
                .then(() => {
                    if (this.$store.getters.containsErrors) {
                        this.error_message = this.$store.getters.getErrors;
                        this.showAlert();
                    } else {
                        this.departmentList = this.$store.getters.getResults.data;
                        // this.subCatg(this.service_id);
                        // this.subvalue=[];
                    
                        return this.departmentList;
                    }
                });
        },
        resetFilter(){
          this.searchKeyword1= '',
        this.searchKeyword= '',
        this.searchKeyword2= '',
        this.keyword='',
            this.remarks = '';
            this.time = '';
            this.address = '';
            this.date = '';
            this.dayArrCalendar = [];
            this.dateFilter(0);
        },
      getBranchList(company) {
            // console.log(moment().subtract(16, 'years').format('DD-MM-YYYY'));
            return this.$store.dispatch(POST_API, {
                    data:{
                        company_id: company != '' ? company.id : '',
                    },
                    api: '/api/dp-jobs-branch-list'
                })
                .then(() => {
                    if (this.$store.getters.containsErrors) {
                        this.error_message = this.$store.getters.getErrors;
                        this.showAlert();
                    } else {
                        this.branchList = this.$store.getters.getResults.data;
                        console.log(this.branchList, 'brlist');
                        return this.branchList;
                    }
                });
        },
        select_all_fields_fun($event){
            if($event != null){
                var $event = $event;
            }else{
                var $event = $event;
            }

            this.form.update_job_title = $event,
            this.form.update_job_scope = $event,
            this.form.update_job_requirement = $event,
            this.form.update_work_site_contact_person = $event,
            this.form.update_work_site_contact_person_country_code = $event,
            this.form.update_work_site_contact_person_mobile_number = $event,
            this.form.update_work_site_contact_person_2 = $event,
            this.form.update_work_site_contact_person_2_country_code = $event,
            this.form.update_work_site_contact_person_2_mobile_number = $event,
            this.form.update_remarks = $event,
            this.form.update_start_time = $event,
            this.form.update_hours = $event,
            this.form.update_per_hour_cost = $event,
            this.form.update_platform_fee = $event,
            this.form.update_vacancy = $event,
            this.form.update_true_vacancy = $event,
            this.form.update_address = $event,
            this.form.update_location_instructions = $event,
            this.form.update_lunch_pay = $event,
            this.form.update_service_category,
            this.form.update_unit = $event,
            this.form.update_assigned_to = $event,
            this.form.update_hygiene_cert = $event,
            this.form.update_medical_history = $event
            this.form.update_is_ot = $event
            this.form.update_is_perm_partime = $event
            this.form.update_gender = $event
            // this.form.update_race_id = $event
            this.form.update_age_range = $event
            this.form.update_department = $event
            this.form.update_branch = $event


        },
      hyiegne_cert($event){
            if($event != null){
                this.form.is_hygiene_cert_req = $event;
            }else{
                this.form.is_hygiene_cert_req = $event;
            }
        },
        medical_hist($event){
            if($event != null){
                this.form.medical_history = $event;
            }else{
                this.form.medical_history = $event;
            }
        },
        cpf_paid($event){
            if($event != null){
                this.form.cpf_not_paid = $event;
            }else{
                this.form.cpf_not_paid = $event;
            }
        },
      insuredFlList() {
            // console.log(moment().subtract(16, 'years').format('DD-MM-YYYY'));
            return this.$store.dispatch(POST_API, {
                    data:{
                        start: this.dateRange.startDate ? moment(this.dateRange.startDate).format('YYYY-MM-DD') : '',
                        end: this.dateRange.endDate ? moment(this.dateRange.endDate).format('YYYY-MM-DD') : '',
                        data_format:this.insurance_data_format
                    },
                    api: '/api/mail-insured-fl-list'
                })
                .then(() => {
                    if (this.$store.getters.containsErrors) {
                        this.error_message = this.$store.getters.getErrors;
                        this.showAlert();
                    } else {
                      this.success_message = this.$store.getters.getResults.data.message;
                      this.showSuccessAlert(this.success_message)
                      this.$router.push({ name: 'dp-jobs', params: { from:this.$route.params.from} });
                    }
                });
        },
      awardBadge() {
            // console.log(moment().subtract(16, 'years').format('DD-MM-YYYY'));
            return this.$store.dispatch(POST_API, {
                    data:{
                        badge_id:this.badgeName,
                        user_id:this.flName,
                        company_id:this.companyName,
                        remarks:this.badge_remarks

                    },
                    api: '/api/assign-badge-to-fl'
                })
                .then(() => {
                    if (this.$store.getters.containsErrors) {
                        this.error_message = this.$store.getters.getErrors;
                        this.showAlert();
                    } else {
                      this.success_message = this.$store.getters.getResults.data.message;
                      this.showSuccessAlert(this.success_message)
                      this.$router.push({ name: 'dp-jobs', params: { from:this.$route.params.from} });
                    }
                });
        },
      getData2(value) {
            this.fl_id = value.map(a => a.id);
        },
        getData1(value) {
            if(value != null){
                var v = Object.values(value);
                this.sup = v[0];
            }else{
                this.sup = null;
            }
        },
        getBadges(){
            this.badgeList = [];
            return this.$store.dispatch(POST_API, {
                data:{
                    
                },
                api:'/api/badge-list',
            })
            .then(() => {
                if (this.$store.getters.containsErrors) {
                    this.error_message = this.$store.getters.getErrors;
                    this.showAlert();
                } else { 

                    this.badgeList = this.$store.getters.getResults.data;
                    return this.badgeList;
                }
            });
        },
        reviveApplicants() {
            // console.log(moment().subtract(16, 'years').format('DD-MM-YYYY'));
            return this.$store.dispatch(POST_API, {
                    data:{
                        job_id: this.job_id,
                        user_id: this.flName.id,
                        subjected_to_late_penalty: false,
                        job_type:'upcoming',
                        revive_with : this.add_type,
                        // type: this.add_type == 'as_selected' ? 'revive_job' : '',
                        arrival_time_next_day: false,
                        awarded_by:this.user_id,
                    },
                    api: '/api/revival-v1'
                })
                .then(() => {
                    if (this.$store.getters.containsErrors) {
                        this.error_message = this.$store.getters.getErrors;
                        this.showAlert();
                    } else {
                      this.success_message = this.$store.getters.getResults.data.message;
                      this.showSuccessAlert(this.success_message)
                      this.$router.push({ name: 'dp-jobs', params: { from:this.$route.params.from} });
                    }
                });
        },
        downloadList(){
            
            var base_url = this.webUrlV1;

            var export_url = '/api/download-multiple-selected-fl-list/'+this.companyName.id+'/'+moment(this.job_date).format('YYYY-MM-DD')+'/'+this.data_format;

            window.open(base_url+export_url,'_blank')
               
        },
        getAsyncFlList(response) {
        return this.$store.dispatch(POST_API, {
                data:{
                    keyword:response,
                    user_type : 'multiple',
                    company_id: this.companyName != null ? (typeof this.companyName === 'object' ? this.companyName.id : this.companyName) : '',
                    type:'add_applicant'
                },
                api: '/api/manage-job-fl-list'
            })
            .then(() => {
                if (this.$store.getters.containsErrors) {
                    this.error_message = this.$store.getters.getErrors;
                    this.showAlert();
                } else {
                    this.selectedFl = this.$store.getters.getResults.data;
                    
                    return this.selectedFl;
                }
            });


        },
        instruction_img($event){
            if($event != null){
                this.instruction_images = $event;
            }else{
                this.instruction_images = $event;
            }
        },
        asyncFind (query) {
            this.isLoading = true
            this.getAsyncFlList(query).then(response => {
                this.mwSearch = response
                this.isLoading = false
            })
        },
        onApplicantChange(type = null)
        {   
            console.log(this.withdraw_type, 'withdraw_type')
            if(this.withdraw_type == "revive"){
                
                this.form.select_all_jobs = false;
                this.jobName = [];

            }

            this.selectedJob = [];
            return this.$store.dispatch(POST_API, {
                data:{
                    type:this.withdraw_type,
                    revive_with:this.revive_with,
                    user_id:this.flName.id,
                    start_time: this.dateRange.startDate ? moment(this.dateRange.startDate).format('YYYY-MM-DD HH:mm:ss') : '',
                    end_time: this.dateRange.endDate ? moment(this.dateRange.endDate).format('YYYY-MM-DD HH:mm:ss') : '',
                },
                api:'/api/upcoming-jobs',
            })
            .then(() => {
                if (this.$store.getters.containsErrors) {
                    this.error_message = this.$store.getters.getErrors;
                    this.showAlert();
                } else { 

                    this.selectedJob = this.$store.getters.getResults.data.data;

                    if(this.selectedJob.length == 0 ){
                        this.disabled_select_all_jobs = true
                    }else{
                        this.disabled_select_all_jobs = false
                    }

                    return this.selectedJob;
                }
            });

        },
        cancelApplicants() {
            // console.log(moment().subtract(16, 'years').format('DD-MM-YYYY'));
            return this.$store.dispatch(POST_API, {
                    data:{
                        job_id:this.job_id,
                        user_id:this.flName.id,
                        type:this.withdraw_type,
                        cancellation_reason:this.cancellation_reason,
                        cancelled_by:this.user_id,
                        actual_withdrawn_by:this.actual_withdrawn_by
                    },
                    api: '/api/cancel-applicant-from-multiple-jobs'
                })
                .then(() => {
                    if (this.$store.getters.containsErrors) {
                        this.error_message = this.$store.getters.getErrors;
                        this.showAlert();
                    } else {
                      this.success_message = this.$store.getters.getResults.data.message;
                      this.showSuccessAlert(this.success_message)
                        this.$router.push({ name: 'dp-jobs', params: { from:this.$route.params.from} });
                    }
                });
        },
        addFl() {
            // console.log(moment().subtract(16, 'years').format('DD-MM-YYYY'));
            return this.$store.dispatch(POST_API, {
                    data:{
                        job_id:this.job_id,
                        user_id:this.fl_id,
                        add_with:this.add_with,
                        opt_insurance:this.insurance_opted,
                        insurance_future_required:this.insurance_future_required,
                        created_by:this.user_id,
                        from_v2:"yes"
                    },
                    api: '/api/add-multiple-fl'
                })
                .then(() => {
                    if (this.$store.getters.containsErrors) {
                        this.error_message = this.$store.getters.getErrors;
                        this.showAlert();
                    } else {
                        this.success_message = this.$store.getters.getResults.data.message;
                        this.showSuccessAlert(this.success_message)
                        this.$router.push({ name: 'dp-jobs', params: { from:this.$route.params.from} });
                    }
                });
        },
      select_all_jobs_fun($event){
            if($event != null){
                var $event = $event;
            }else{
                var $event = $event
            }
            
            if($event == true){
                this.jobName = this.selectedJob;

                if(this.jobName.length > 0){
                    this.getData(this.jobName)
                }
            }else{
                this.jobName = [];

            }            
        },
      formatDate(date) {
            return moment(date).format('DD-MM-YYYY');
          },
          cancelJobs() {
            // console.log(moment().subtract(16, 'years').format('DD-MM-YYYY'));
            return this.$store.dispatch(POST_API, {
                    data:{
                        job_id:this.job_id,
                        cancellation_reason:this.cancellation_reason,
                        cancelled_by:this.user_id,
                        user_type_id:this.user_type_id
                    },
                    api: '/api/cancel-multiple-jobs'
                })
                .then(() => {
                    if (this.$store.getters.containsErrors) {
                        this.error_message = this.$store.getters.getErrors;
                        this.showAlert();
                    } else {
                      this.success_message = this.$store.getters.getResults.data.message;
                      this.showSuccessAlert(this.success_message)
                      this.$router.push({ name: 'dp-jobs', params: { from:this.$route.params.from} });
                    }
                });
        },
      getCompanyList() {
      this.$store
        .dispatch(POST_API, {
          data: {
            authUserID: this.user_id,
            from_v2: "yes",
          },
          api: "/api/company-listing-dp-manage-job",
        })
        .then(() => {
          if (this.$store.getters.containsErrors) {
            this.error_message = this.$store.getters.getErrors;

            this.$swal({
              position: "center",
              // icon: 'error',
              imageUrl: "/assets/images/404_elcy.gif",
              customClass: {
                container: "mascot_error_container",
              },
              title: this.error_message,
              showConfirmButton: false,
              timer: 1500,
            });
          } else {
            this.selectedCompany = this.$store.getters.getResults.data;
            return this.selectedCompany;
          }
        });
    },
    clear(){
      this.supName=[],
      this.jobName = [];
      this.companyName=[],
      this.flName="",
      this.cancellation_reason=""
      this.selectedJob=[]
    },
    getData(value) {
            this.job_id = value.map(a => a.id);
            this.getJobData(this.job_id);

        },
    submit() {
      // your logic for when Update Job is clicked
      console.log('Submit clicked');
    },
    dateFilter(type){
            
            this.onCompanyChange(this.companyName,type);
        },
        getSupervisorsList(value) {
           
           return this.$store.dispatch(POST_API, {
                   data:{
                       id:[value.id],
                       type:'multiple',

                   },
                   api: '/api/supervisors-for-multiple-jobs'
               })
               .then(() => {
                   if (this.$store.getters.containsErrors) {
                       this.error_message = this.$store.getters.getErrors;
                       this.showAlert();
                   } else {
                       this.selectedSupervisor = this.$store.getters.getResults.data.data;
                       
                       return this.selectedSupervisor;
                   }
               });
       },
       showAlert() {
      this.dismissCountDown = this.dismissSecs;
      this.$swal({
        position: "top-center",
        type: "error",
        text: this.error_message,
        showConfirmButton: false,
        timer: 3000,
      });
    },
    getFlList(type, award_badge = false, company_id = null) {
      this.clear()
      if(award_badge == true){
          this.getBadges();
      }

      if(type == "revival"){
          this.withdraw_type = 'revive';
          var user_type = '';

      }else{
          var user_type = 'multiple';
      }

      // console.log(moment().subtract(16, 'years').format('DD-MM-YYYY'));
      return this.$store.dispatch(POST_API, {
              data:{
                user_type : user_type,
                company_id: (company_id != null ? company_id : ''),
                type:type
              },
              api: '/api/manage-job-fl-list'
          })
          .then(() => {
              if (this.$store.getters.containsErrors) {
                  this.error_message = this.$store.getters.getErrors;
                  this.showAlert();
              } else {
                  this.selectedFl = this.$store.getters.getResults.data;
                  
                  return this.selectedFl;
              }
          });


      },
    onCompanyChange(value,type)
        {   
            console.log(type,'type')
            this.getSupervisorsList(value);

            if(type == 1){
                this.keyword = this.searchKeyword1
                // this.getFlList('add_applicant', false, (value != null ? value.id : ''));

            }else if(type == 2){
                this.keyword = this.searchKeyword2

            }else{
                this.keyword = this.searchKeyword

            }
            this.form.select_all_jobs = false;
            this.form.department = '';
            this.form.update_department = 'no';
            this.has_department = 'no';

            this.jobName = '';


            return this.$store.dispatch(POST_API, {
                    data:{
                        id:[value.id],
                        type:'multiple',
                        start_time: this.dateRange.startDate ? moment(this.dateRange.startDate).format('YYYY-MM-DD HH:mm:ss') : '',
                        end_time: this.dateRange.endDate ? moment(this.dateRange.endDate).format('YYYY-MM-DD HH:mm:ss') : '',
                        time:this.time ? this.time.map(obj => obj.start_time):  null,
                        address:this.address ? this.address.map(obj => obj.address):  null,
                        day_type:this.dayArrCalendar ? this.dayArrCalendar : null,
                        date:this.date ? moment(this.date).format('YYYY-MM-DD') : null,
                        keyword:this.keyword
                    },
                    api:'/api/upcoming-jobs',
                })
                .then(() => {
                    if (this.$store.getters.containsErrors) {
                        this.error_message = this.$store.getters.getErrors;
                        this.showAlert();
                    } else { 
                        
                        this.selectedJob = this.$store.getters.getResults.data.data
                        this.selectedTime = this.selectedJob.filter((job, index, self) => {
                            return index === self.findIndex(j => j.start_time === job.start_time);
                        });
                        this.selectedAddress = this.selectedJob.filter((job, index, self) => {
                           return index === self.findIndex(j => j.address === job.address);
                        })
                        this.selectedDate = this.selectedJob.filter((job, index, self) => {
                            return index === self.findIndex(j => j.start_date === job.start_date);
                        });

                        if(this.selectedJob.length == 0 ){
                            this.disabled_select_all_jobs = true
                        }else{
                            this.disabled_select_all_jobs = false
                        }
                        this.getBranchList(value);
                        this.getDepartments(value.id);

                        return this.selectedJob;
                    }
                });

        },
        getJobData(id) {

return this.$store.dispatch(POST_API, {
        data:{
            ids:id
        },
        api: '/api/get-job-data'
    })
    .then(() => {
        if (this.$store.getters.containsErrors) {
            this.error_message = this.$store.getters.getErrors;
            this.showAlert();
        } else {
            this.items = this.$store.getters.getResults.data.data;
            this.form.title = this.items.title;
            this.form.description = this.items.description;
            this.form.job_scope = this.items.job_scope;
            this.form.remarks = this.items.remarks;
            this.form.working_hour = this.items.working_hours;
            this.form.price = parseFloat(this.items.hourly_cost);
            this.platform_fee_title = ( this.items.service_fee_type == 'fixed_rate' ? (this.items.jobOnHoliday ? 'Holiday Fee' : 'Fixed Fee') : 'Platform Fee Percent');
            this.form.platform_fee = ( this.items.service_fee_type == 'fixed_rate' ? this.items.service_fee : this.items.service_fee_per);
            this.form.vacancy = this.items.total_vacancies;
            this.form.true_vacancy = this.items.true_vacancies;
            this.form.cpf_not_paid = this.items.cpf_not_paid == 'yes' ? true : false;
            this.form.addressValueData = this.items.address;
            this.lunch_pay_not_provided = this.items.lunch_pay_not_provided;
            this.form.lunch_pay_hours = (this.lunch_pay_not_provided == 'yes' ? this.items.lunch_pay_hours : 0);
            this.form.is_ot = this.items.is_ot;
            this.form.is_perm_partime = this.items.is_perm_partime;
            this.form.unit = this.items.unit;
            this.form.is_hygiene_cert_req = this.items.is_hygiene_cert_req != null ? (this.items.is_hygiene_cert_req == 'yes' ? true : false) : '';
            this.form.medical_history = this.items.medical_history != null ? (this.items.medical_history == 'yes' ? true : false) : '';
            this.form.gender = this.items.gender;
            // this.form.race_id = this.items.race_id;
            this.form.min_age = this.items.min_age;
            this.form.max_age = this.items.max_age;
            this.form.status = this.items.status;
            this.form.department = this.items.department;
            this.has_department = (this.items.job_company != null ? this.items.job_company.has_department : 'no');
            this.form.branch = this.items.branch;


            this.start = this.items.start_time
            if(this.start)
            {
                this.startArray = this.start.split(':');
                this.form.starttime.hh = this.startArray[0] > 12 ? this.startArray[0]-12 : this.startArray[0];
               if(this.form.starttime.hh.length){
                 (this.form.starttime.hh.length != 2) ? this.form.starttime.hh=("0" + this.form.starttime.hh) : this.form.starttime.hh;
                 }else{
                 (this.form.starttime.hh < 10) ? this.form.starttime.hh=("0" + this.form.starttime.hh) : this.form.starttime.hh;
                }
                this.form.starttime.mm = this.startArray[1] ? this.startArray[1] : '00';
                this.form.starttime.A = this.startArray[0] >= 12 ? 'PM' : 'AM' ;
            }
            else
            {
                this.form.starttime.hh = '00',
                this.form.starttime.mm = '00';
                this.form.starttime.A = 'AM';
            }

            this.work_site_contact_person = this.items.work_site_contact_person;
            this.work_site_contact_person_country_code = this.items.work_site_contact_person_country_code;
            this.work_site_contact_person_mobile_no = this.items.work_site_contact_person_mobile_no;
            this.work_site_contact_person_2 = this.items.work_site_contact_person_2;
            this.work_site_contact_person_2_country_code = this.items.work_site_contact_person_2_country_code;
            this.work_site_contact_person_2_mobile_no = this.items.work_site_contact_person_2_mobile_no;
            
            this.instruction_images = this.items.job_instruction_imgs.length > 0 ? 'yes' : 'no';
            this.form.categoryValue = this.items.service_categories_id != 0 ? this.items.service_categories_id : '';
            
            var imgs = [];
            imgs = this.items.job_instruction_imgs;
            
            if(imgs){
                imgs.forEach(function(key, index) {
                    delete key.job_id;
                    delete key.img_id;

                })
                this.initialSelected = imgs;
            }
            
            this.markers = [];
            let marker = {
                lat: parseFloat(this.items.lat),
                lng: parseFloat(this.items.long)
                };

            this.markers.push({ position : marker });
            console.log(marker, 'markers');
            // this.addMarker();
            // this.places.push(this.currentPlace);
            this.center = marker;

            var sum_hrs = parseFloat(this.items.working_hours) + parseFloat(this.items.lunch_pay_hours);
           
            if(this.items.lunch_pay_not_provided == 'yes'){

                this.form.hours = this.isInteger(sum_hrs) ? Math.floor(sum_hrs) : Math.floor(sum_hrs);
            }else{
                this.form.hours = this.isInteger(this.items.working_hours) ? this.items.working_hours : Math.floor(this.items.working_hours);
            }
            var h = sum_hrs.toString();

            var split = this.isInteger(h) ? [h] : h.split(".");
          
            if(split.length > 1){
                if(split[1] == '25'){
                    // this.form.hours = (this.form.hours - 1);
                    this.form.working_minutes = '15';
                }else{
                    this.form.working_minutes = split[1] == '75' ? '45' : (split[1] == '5' ? '30' : (split[1] == '25' ? '15' : '00'));
                }
            }else{
                this.form.working_minutes = '00'
            }
            // console.log(sum_hrs, 'sum_hrs', this.form.working_minutes);
            // this.form.working_minutes = this.isInteger(sum_hrs) ? '00' : (sum_hrs == '.25' ? 15 : '30' )
            
            this.getGallery(this.items.assigned_to);

            this.subCatg(this.form.categoryValue);

        }
    });
},
isInteger(num) {
            return num.toString().indexOf('.') === -1;
        },
getGallery(id) {
            return this.$store.dispatch(POST_API, {
                    data:{
                        type:'multiple',
                        user_id:id
                    },
                    api: '/api/get-gallery-records-dp-manage-job'
                })
                .then(() => {
                    if (this.$store.getters.containsErrors) {
                        this.error_message = this.$store.getters.getErrors;
                        this.showAlert();
                    } else {
                        this.dataImages = this.$store.getters.getResults.data;

                        return this.dataImages;
                    }
                });
        },
subCatg(value) {
            this.form.categoryValue =value;
            // console.log(this.form.serviceCategories,this.oldCatVal,value)
            if(value != this.oldCatVal){
                this.subvalue=[];
            }
            // if(this.form.categoryValue){
            return this.$store.dispatch(POST_API, {
                    data:{id:value},
                    api: '/api/sub-service-category-value',
                })
                .then(() => {
                    if (this.$store.getters.containsErrors) {
                        this.error_message = this.$store.getters.getErrors;
                        this.showAlert();
                    } else {
                        this.subCategories = this.$store.getters.getResults.data.name;
                        if(this.subCategories != 'F & B'){
                            this.form.is_hygiene_cert_req = false;
                            this.form.medical_history = false;
                        }
                        return this.subCategories;
                    }
                });
            // }
        },
      locationPtuser(job_id, id) {
        this.job_id = job_id;
        this.getLatLong().then(() => {
          this.geolocate();
          // this.$refs.address.focus();
          this.setPlace(this.currentPlace);
          this.addMarker();
        });
        this.form.user_id = id;
        this.$refs["location-modal"].show();
      },
      clearLatlong() {
        this.center = { lat: 0, lng: 0 };
        // this.latlongMarker = [];
      },
      geolocate: function () {
        navigator.geolocation.getCurrentPosition((position) => {
          this.center = {
            lat: +position.coords.latitude,
            lng: +position.coords.longitude,
          };
        });
      },
      show(action) {
        if (this.user_type_id == 2) {
          return this.actions.indexOf(action) >= 0 ? true : false;
        } else {
          return true;
        }
      },
      addMarker() {
        if (this.currentPlace) {
          const marker = {
            lat: +parseFloat(this.currentPlace.geometry.location.lat()),
            lng: +parseFloat(this.currentPlace.geometry.location.lng()),
          };
          this.form.formattedAddress = this.currentPlace.formatted_address;
          this.form.addressValueData =this.currentPlace.formatted_address;
          this.markers.push({ position: marker });
          this.places.push(this.currentPlace);
          this.center = marker;
          this.currentPlace = null;
        }
      },
      setPlace(place) {
        this.currentPlace = place;
        this.addMarker();
      },
      getLatLong() {
        return this.$store
          .dispatch(POST_API, {
            data: {
              job_id: this.job_id,
              user_id: this.logged_user_id,
              // status: status ? status : 'in-progress',
              // servicesFilter: userServices ? userServices : 'all',
              page: this.currentPage,
              keyword: this.filterSearchRate,
              page: this.currentPage,
              rowsPerPage: this.form.rowsPerPage,
              sortBy: this.sortBy,
              sortDirection: this.sortDirection,
              sortDesc: this.sortDesc,
            },
            api: "/api/get-latlong",
          })
          .then(() => {
            if (this.$store.getters.containsErrors) {
              this.error_message = this.$store.getters.getErrors;
              this.showAlert();
            } else {
              this.marker = this.$store.getters.getResults.data.latLong;
              this.jobMarker = this.$store.getters.getResults.data.job_location;
              this.updatelatlongMarker();
            }
          });
      },
      updatelatlongMarker() {
        var markers = [];
        $.each(this.marker, function (index, val) {
          var icon = {
            url: val.candidate_profile.profile_image, // url
            scaledSize: new google.maps.Size(30, 30), // scaled size
            // radius:20,
            origin: new google.maps.Point(0, 0), // origin
            anchor: new google.maps.Point(0, 0), // anchor
            labelClass: "labelIconlabelIcon",
            //shape:{coords:[17,17,18],type:"circle"},
            //set optimized to false otherwise the marker  will be rendered via canvas
            //and is not accessible via CSS
            // optimized:false,
            // title: 'spot'
            // path: google.maps.SymbolPath.CIRCLE,
            // scale: 8.5,
            // fillColor: "#F00",
            // fillOpacity: 0.4,
            // strokeWeight: 0.4,
            // scaledSize: new google.maps.Size(10,20), // scaled size
            // origin: new google.maps.Point(0,0), // origin
            // anchor: new google.maps.Point(0, 32) // anchor
          };
          markers.push({
            position: { lat: Number(val.current_lat), lng: Number(val.current_long) },
            icon: icon,
            labelClass: "labelIcon",
            // icon:val.candidate_profile.profile_image,
            type: "ptuser",
            //shape:{coords: [0,0,3,3], type: "rect"},
          });
          // str['long'][index].push(val.current_long);
        });
        var jobmarkers = [];
        $.each(this.jobMarker, function (index, val) {
          markers.push({
            position: { lat: Number(val.lat), lng: Number(val.long) },
            type: "company",
          });
          // str['long'][index].push(val.current_long);
        });
        this.latlongMarkers = markers;
        this.center = { lat: 0, lng: 0 };
        setTimeout(() => {
          this.center = this.latlongMarkers[0].position;
        }, 500);
      },
  
      cancelApplicant(id, job_id, key) {
  
        console.log(id,job_id)
        // this.form.username = name;
        this.cancellation_reason = "";
        this.applicant_cancellation_reason = "";
        this.user_id = id;
        this.job_id = job_id;
        this.keyVal = key;
        this.$refs["cancel-modal"].show();
      },
      onSubmitReview(evt) {
        evt.preventDefault();
        this.$refs["review-modal"].hide();
        this.$store
          .dispatch(POST_API, {
            data: {
              job_id: this.job_id,
              user_id: this.user_id,
              review: this.review1,
              rating: this.rating,
              logged_user_id: this.logged_user_id,
            },
            api: "/api/supervisor-rate-ptuserWeb",
          })
          .then(() => {
            if (this.$store.getters.containsErrors) {
              this.error_message = this.$store.getters.getErrors;
              this.showAlert();
            } else {
              this.success_message = this.$store.getters.getResults.message;
              this.form.review = "";
              this.form.user_id_id = "";
              this.rating = "";
              //this.$refs['review-modal'].hide();
              this.showSuccessAlert(this.success_message);
              // this.changeApplicantTabStatus(
              //   this.activeTab,
              //   this.activeApplicantTab,
              //   this.job_id,
              //   this.keyVal,
              //   this.user_id
              // );
  
                    this.getList(this.job_id, "", this.activeTab, this.user_id);
  
              // this.changeTabStatus(this.activeTab, this.activeApplicantTab, this.filterSearch);
              // window.location.reload();
              //this.getList(this.activeTab,'selected',this.filterSearch);
              // this.$router.push({ name: 'ViewJobDetailCompleted' });
            }
          });
      },
      
      showAlertCancel() {
        this.$swal({
          position: "center",
          // icon: 'error',
          imageUrl: "/assets/images/404_elcy.gif",
          customClass: {
            container: "mascot_error_container",
          },
          title: this.error_messages_cancel,
          showConfirmButton: false,
          timer: 1500,
        });
      },
      btoa(id) {
        return btoa(id);
      },

      
      
      
      showPermissionEM(action) {
        if (
          this.$store.getters.currentUser.is_company_head == "no" &&
          (this.$store.getters.currentUser.user_type_id == 3 ||
            this.$store.getters.currentUser.user_type_id == 4)
        ) {
          return this.permissionActions.indexOf(action) >= 0 ? true : false;
        } else {
          return true;
        }
      },
      
  
      getJobdtb() {
        [{ posted_by: 1655 }];
      },
      formSubmit() {
            console.log(this.form.gender, this.form.min_age,this.form.max_age);
       
            if(this.dateArr.length > 10){
                this.error_message = 'Maximum 10 days jobs can be created in one time.';
                this.showAlert();
            }else{
                this.$swal({
                    title: 'Please Confirm',
                    text: 'Are you sure you want to continue with multiple job update?',
                    type: 'warning',
                    position: 'center',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No'
                })
                .then(result => {
                    if (result.value) {
                        this.$store.dispatch(POST_API, {
                            data: {
                                user_id:this.user_id,
                                company_id:this.company_id,
                                user_type_id:this.user_type_id,
                                job_id: this.job_id,
                                is_hygiene_cert_req:this.form.is_hygiene_cert_req == true ? 'yes' : null,
                                medical_history:this.form.medical_history == true ? 'yes' : null,
                              
                                title: this.form.title,
                                description: this.form.description,
                                job_scope: this.form.job_scope,
                                remarks: this.form.remarks,
                                address: this.form.addressValueData ,
                                working_hours: (this.form.working_minutes == '00' || this.form.working_minutes == '' || this.form.working_minutes == null) ? this.form.hours + '.0' : ((this.form.working_minutes == '45') ? this.form.hours + '.75' : ((this.form.working_minutes == '15') ? this.form.hours + '.25' : this.form.hours +'.5')),
                                cpf_not_paid: this.form.cpf_not_paid == true ? 'yes' : 'no',
                                vacancy: this.form.vacancy,
                                reset_vacancy_status: this.form.reset_vacancy_status,
                                true_vacancy: this.form.true_vacancy,
                                assigned_to: this.sup,
                                start_time: this.form.starttime,
                                categories: this.form.categoryValue,

                                price: this.form.price,
                                platform_fee:this.form.platform_fee ? this.form.platform_fee : 0,
                                lat: this.center.lat,
                                long: this.center.lng,
                                unit: this.form.unit,
                                lunch_pay_hours : (this.lunch_pay_not_provided == 'yes' ? this.form.lunch_pay_hours : 0),
                                lunch_pay_not_provided: this.lunch_pay_not_provided,
                                work_site_contact_person: this.work_site_contact_person,
                                work_site_contact_person_country_code: this.work_site_contact_person_country_code,
                                work_site_contact_person_mobile_no: this.work_site_contact_person_mobile_no,
                                work_site_contact_person_2: this.work_site_contact_person_2,
                                work_site_contact_person_2_country_code: this.work_site_contact_person_2_country_code,
                                work_site_contact_person_2_mobile_no: this.work_site_contact_person_2_mobile_no,
                                instruction_images : this.initialSelected,
                                instruction_images_checked : this.instruction_img,
                                is_ot: this.form.is_ot,
                                is_perm_partime: this.form.is_perm_partime,
                                gender:this.form.gender ? this.form.gender : null,
                                // race_id:this.form.race_id ? this.form.race_id : null,
                                min_age:this.form.min_age ? this.form.min_age : null,
                                max_age:this.form.max_age ? this.form.max_age : null,
                                department: this.form.department,
                                branch: this.form.branch,

                                update_job_title : this.form.update_job_title,
                                update_job_scope : this.form.update_job_scope,
                                update_job_requirement : this.form.update_job_requirement,
                                update_work_site_contact_person:this.form.update_work_site_contact_person,
                                update_work_site_contact_person_country_code:this.form.update_work_site_contact_person_country_code,
                                update_work_site_contact_person_mobile_number:this.form.update_work_site_contact_person_mobile_number,
                                update_work_site_contact_person_2:this.form.update_work_site_contact_person_2,
                                update_work_site_contact_person_2_country_code:this.form.update_work_site_contact_person_2_country_code,
                                update_work_site_contact_person_2_mobile_number:this.form.update_work_site_contact_person_2_mobile_number,
                                
                                update_remarks:this.form.update_remarks,
                                update_start_time:this.form.update_start_time,
                                update_hours:this.form.update_hours,
                                update_per_hour_cost:this.form.update_per_hour_cost,
                                update_platform_fee:this.form.update_platform_fee,
                                update_vacancy:this.form.update_vacancy,
                                update_true_vacancy:this.form.update_true_vacancy,
                                update_address:this.form.update_address,
                                update_location_instructions: this.form.update_location_instructions,
                                update_lunch_pay: this.form.update_lunch_pay,
                                update_service_category: this.form.update_service_category,
                                update_unit: this.form.update_unit,
                                update_assigned_to: this.form.update_assigned_to,
                                update_hygiene_cert: this.form.update_hygiene_cert,
                                update_medical_history: this.form.update_medical_history,
                                update_is_ot: this.form.update_is_ot,
                                update_is_perm_partime: this.form.update_is_perm_partime,
                                update_gender: this.form.update_gender,
                                // update_race_id: this.form.update_race_id,
                                update_age_range: this.form.update_age_range,
                                update_department: this.form.update_department,
                                update_branch: this.form.update_branch,


                            },
                            api: "/api/update_multiple_jobs",
                        })
                        .then(() => {
                    if (this.$store.getters.containsErrors) {
                        this.error_message = this.$store.getters.getErrors;
                        this.showAlert();
                    } else {
                        if(this.$store.getters.getResults.title_mismatch == true){
                            var msg = 'The jobs selected seems to have different job titles, the job details will be overridden. Do you want to continue?';
                            this.$swal({
                                title: 'Please Confirm',
                                text: msg,
                                type: 'warning',
                                position: 'center',
                                showCancelButton: true,
                                confirmButtonColor: '#3085d6',
                                cancelButtonColor: '#d33',
                                confirmButtonText: 'Yes',
                                cancelButtonText: 'No'
                            })
                        }else{
                          this.success_message = this.$store.getters.getResults.message;
                            this.showSuccessAlert(this.success_message);
                            this.$router.push({ name: 'dp-jobs', params: { from:this.$route.params.from} });
                        }
                    }
                });
                    }
                });
            }
        },

      getServiceCategory() {
        return this.$store
          .dispatch(POST_API, {
            api: "/api/service-categories-new-dp",
          })
          .then(() => {
            if (this.$store.getters.containsErrors) {
              this.error_message = this.$store.getters.getErrors;
              this.showAlert();
            } else {
              this.serviceCategories = this.$store.getters.getResults.data;
              return this.serviceCategories;
            }
          });
      },
      getAllCompanies() {
        return this.$store
          .dispatch(POST_API, {
            data: {},
            api: "api/employer-for-ptuser",
          })
          .then(() => {
            if (this.$store.getters.containsErrors) {
              this.error_message = this.$store.getters.getErrors;
              this.showAlert();
            } else {
              this.allCompanies = this.$store.getters.getResults.data;
              return this.allCompanies;
            }
          });
      },
      
      showSuccessAlert(message) {
        this.$swal({
          position: "top-center",
          type: "success",
          text: message,
          showConfirmButton: false,
          timer: 3000,
        });
      },
      permission() {
        if (JwtService.getMenuPermission()) {
          if (this.user_type_id == 2) {
            var menu = JSON.parse(JwtService.getMenuPermission());
            this.actions = getPermission(menu, "Manage Jobs");
          }
        }
      },
      show(action) {
        if (this.user_type_id == 2) {
          return this.actions.indexOf(action) >= 0 ? true : false;
        } else {
          return true;
        }
      },

      
      getCostList() {
        return this.$store
          .dispatch(POST_API, {
            api: "/api/per-hour-cost-listing",
          })
          .then(() => {
            if (this.$store.getters.containsErrors) {
              this.error_message = this.$store.getters.getErrors;
              this.showAlert();
            } else {
              this.costListing = this.$store.getters.getResults.data.data;
              return this.costListing;
            }
          });
      },
  
     
      customFormatterTwo(date) {
        return moment(date).format("DD-MM-YYYY");
      },
     
      showAlertRate() {
        window.scrollTo(0, 0);
        this.dismissCountDownRate = this.dismissSecsRate;
      },
      showAlertExtend() {
        this.dismissCountDown = this.dismissSecs;
        this.$swal({
          position: "top-center",
          type: "error",
          text: this.error_messages_extend,
          showConfirmButton: false,
          timer: 3000,
        });
      },
      countDownChangedExtend(dismissCountDownExtend) {
        this.dismissCountDownExtend = dismissCountDownExtend;
      },
      countDownChangedSuspend(dismissCountDownSuspend) {
        this.dismissCountDownSuspend = dismissCountDownSuspend;
      },
      showAlertSuspend() {
        this.dismissCountDown = this.dismissSecs;
        this.$swal({
          position: "top-center",
          type: "error",
          text: this.error_messages_suspend,
          showConfirmButton: false,
          timer: 3000,
        });
      },
      // cancelApplicant(id) {
      //   // this.form.username = name;
      //   this.form.cancellation_reason = "";
      //   this.form.user_id = id;
      //   this.$refs["cancel-modal"].show();
      // },
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length;
        this.currentPage = 1;
      },
      toggleInfoWindow: function (marker, idx) {
  
        if (marker.type == "ptuser") {
          // this.loc1 = new Location("");
  
          this.infoWindowPos = marker.position;
  
          this.getDistance(
            this.jobMarker[0].lat,
            this.jobMarker[0].long,
            this.marker[idx].current_lat,
            this.marker[idx].current_long,
            marker,
            idx
          );
        } else {
          this.infoWindowPos = marker.position;
          this.infoContent = this.getInfoWindowContent(marker, idx, this.jobMarker);
        }
  
        //check if its the same marker that was selected if yes toggle
        if (this.currentMidx == idx) {
          this.infoWinOpen = !this.infoWinOpen;
        }
        //if different marker set infowindow to open and reset current marker index
        else {
          this.infoWinOpen = true;
          this.currentMidx = idx;
        }
      },

          getCountryCode() {
            return this.$store.dispatch(GET_API, {
                    api: '/api/countries'
                })
                .then(() => {
                    if (this.$store.getters.containsErrors) {
                        this.error_message = this.$store.getters.getErrors;
                        this.showAlert();
                    } else {
                        this.countries = this.$store.getters.getResults.data;

                        // this.showSuccessPopup();
                    }
                });
        },
  
    },
  
    mounted() {
      $(document).ready(function () {
        // $(document).on('click', '.btn', function(){
        // var moreLessButton = $(".invisible-content").is(':visible') ? 'Read More' : 'Read Less';
        // $(this).text(moreLessButton);
        // $(this).parent('.large-content').find(".invisible-content").toggle();
        // $(this).parent('.large-content').find(".visible-content").toggle();
        // });
      });
  
      //document.title = "EL Connect - Employer - Manage Jobs";
      this.user_id =
        this.$store.getters.currentUser != null ? this.$store.getters.currentUser.id : "";
      this.logged_user_id =
        this.$store.getters.currentUser != null ? this.$store.getters.currentUser.id : "";
      this.charge_type =
        this.$store.getters.currentUser != null ? this.$store.getters.currentUser.charge_type : "";
  
      this.user_type_id =
        this.$store.getters.currentUser != null ? this.$store.getters.currentUser.user_type_id : "";
      this.is_company_head =
        this.$store.getters.currentUser != null
          ? this.$store.getters.currentUser.is_company_head
          : "";
  
      this.company_id =
        this.$store.getters.currentUser != null ? this.$store.getters.currentUser.company_id : "";
      this.company_admin_id =
        this.$store.getters.currentUser != null
          ? this.$store.getters.currentUser.company_admin_id
          : "";
          this.getCompanyList();

  
     
  
          this.getBadges();
      this.getServiceCategory();
      this.getCostList();
        this.getCountryCode();
        this.geolocate();
      
      this.designation = this.$store.getters.currentUser.designation;
  
      this.user_type_id = this.$store.getters.currentUser.user_type_id;
     
    },
  };
  </script>
  
  